// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --bgTop: #04b0fab4;
  --bgMid: rgb(0 108 203 / 93%);
  --ink: #0D1B2A;
  --shadow: 0 8px 14px rgba(13, 27, 42, 0.18);
  --shadowSoft: 0 10px 28px rgba(13, 27, 42, 0.12);
  --radiusLg: 20px;
  --container: 633px;
  --accentBlue: #004b7aa4;
}

html[data-brand="house-helper"] {
  --bgTop: #7cc243;
  --bgMid: #2f7d32;
  --ink: #102318;
  --shadow: 0 8px 14px rgba(24, 83, 33, 0.18);
  --shadowSoft: 0 10px 28px rgba(24, 83, 33, 0.12);
  --accentBlue: #2f7d32;
  --brandPrimary: #2f7d32;
  --brandPrimaryDark: #1b5e20;
  --brandPrimaryBright: #7cc243;
  --brandPrimarySoft: #edf8e7;
  --brandAccent: #f4c430;
}


*{ box-sizing: border-box; }
html, body{ height:100%; }
body{ margin:0; font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial; color: var(--ink); }
a{ color: inherit; text-decoration: none; }
button, select{ font: inherit; }

.page{ min-height:100vh; background: #fcfaf6; }
.container{ width: 760px; 
  max-width: 1100px;
  margin: 0 auto;
}

/* ==========================
   SERVICE PROVIDER PROFILE
   ========================== */

.provider-hero {
  background: linear-gradient(135deg, #1d4ed8, #0ea5e9);
  color: #ffffff;
  padding: 32px 16px;
}

.provider-hero-inner {
  max-width: 730px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 24px;
}

.provider-logo-wrap {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
}

.provider-logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.provider-logo-placeholder {
  font-size: 12px;
  color: #9ca3af;
}

.provider-hero-copy {
  flex: 1;
}

.provider-hero-gallery {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.provider-hero-gallery-button {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: none;
  background: rgba(15, 23, 42, 0.25);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.provider-hero-gallery-button:disabled {
  opacity: 0.4;
  cursor: default;
}

.provider-hero-gallery-strip {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 4px 2px;
}

.provider-hero-thumb-wrap {
  flex: 0 0 auto;
}

.provider-hero-thumb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.25);
  cursor: pointer;
}

.provider-hero-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 6px;
}

.provider-hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 4px;
}

.provider-hero-tags span {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  color: #1e3a8a;
}

.provider-hero-serving {
  font-size: 13px;
  opacity: 0.9;
}

.provider-main {
  max-width: 730px;
  margin: 0 auto;
  padding: 32px 16px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.provider-main-left {
  flex: 3;
}

.provider-photo-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  padding: 18px 20px 16px;
  margin-bottom: 18px;
}

.provider-photo-title {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
}

.provider-photo-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.provider-photo-thumb-wrap {
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.provider-photo-thumb {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.2);
}

.provider-photo-empty {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}

.provider-main-right {
  flex: 1;
}

.provider-table-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.provider-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.provider-table th {
  background: #f9fafb;
  text-align: left;
  padding: 10px 14px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  width: 170px;
}

.provider-table td {
  padding: 10px 14px;
  border-bottom: 1px solid #e5e7eb;
}

.provider-gallery-card {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
  padding: 20px;
}

.provider-gallery-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px;
}

.provider-gallery-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.provider-gallery-img {
  width: 100%;
  height: 150px;
  border-radius: 12px;
  object-fit: cover;
}

.provider-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.provider-modal-content {
  position: relative;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  background: #020617;
  border-radius: 16px;
  padding: 16px 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.provider-modal-image {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 12px;
  object-fit: contain;
}

.provider-modal-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: none;
  background: rgba(15, 23, 42, 0.85);
  color: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.provider-modal-arrow--left {
  left: 10px;
}

.provider-modal-arrow--right {
  right: 10px;
}

.provider-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: none;
  background: rgba(15, 23, 42, 0.9);
  color: #f9fafb;
  font-size: 18px;
  cursor: pointer;
}

/* Mobile tweaks for provider profile */
@media (max-width: 550px) {
  .provider-hero {
    padding: 16px 12px;
  }
  

  .provider-hero-inner {
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
  }

  .provider-logo-wrap {
    width: 68px;
    height: 68px;
  }

  .provider-hero-title {
    font-size: 20px;
  }

  .provider-hero-gallery {
    margin-top: 8px;
  }

  .provider-hero-gallery-strip {
    max-width: 100%;
  }

  .provider-hero-thumb {
    width: 40px;
    height: 40px;
  }
}

.provider-cta-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
  padding: 20px 18px;
}

.provider-cta-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 10px;
}

.provider-cta-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.provider-cta-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.provider-cta-input {
  border-radius: 10px;
  border: 1px solid #d1d5db;
  padding: 8px 10px;
  font-size: 14px;
}

.provider-cta-button {
  margin-top: 4px;
  width: 100%;
  border-radius: 999px;
  border: none;
  padding: 10px 14px;
  background: #16a34a;
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
}

.provider-cta-button:hover {
  background: #15803d;
}

.provider-cta-note {
  margin-top: 8px;
  font-size: 11px;
  color: #6b7280;
}

.provider-request-button {
  margin-top: 4px;
}

@media (min-width: 900px) {
  .provider-main {
    flex-direction: row;
  }
}


/* DEFAULT STYLES ALL SIZES */
@media (max-width: 10568px){

    /* Header */
    .header{
      position: sticky; top: 0; z-index: 20;
      background: rgba(255,255,255,0.10);
      backdrop-filter: blur(10px);
      border-bottom: 1px solid rgba(134, 134, 134, 0.187);
    }
    .headerInner{
      display:flex; align-items:center; justify-content:space-between;
      padding: 16px 0;
    }

    
    .logo{ display:flex; align-items:center; gap: 6px;  color: #0B2A6B; min-width: 0; }
    .homeLink{
      display: inline-flex;
      align-items: center;
      min-width: 0;
      flex: 1 1 auto;
    }
    .logoMark{
        width: 50px;
        height: 50px;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.75);
        display: grid;
        place-items: center;
        box-shadow: var(--shadowSoft);
        color: #FF7A00;
        margin-left: -5px;
        border: solid 1px rgba(0, 0, 0, 0.122);
        
    }
    .logoMark svg{ width: 38px; height: 38px;    margin-top: -5px; }
    .logoText{ line-height: 1.0;padding-right: 15px; min-width: 0; }
    .brand{ font-weight: 900; font-size: 32px; letter-spacing: -0.6px; color: #016faf; }
    .dot{ font-weight: 900; color: #FF7A00; margin-left: -8px; }
    .tagline{ 
              font-size: 11px;
        letter-spacing: 0.6px;
        font-weight: 800;
        opacity: 0.75;
        margin-top: 4px;
     }

    .contractorLink{
      font-weight: 700; color: rgba(255,255,255,0.92);
      padding: 10px 14px; border-radius: 999px;
      border: 1px solid rgba(255,255,255,0.22);
      background: rgba(13,27,42,0.10);
      color:rgb(0, 166, 255);
    }
    .contractorLink:hover{ background: rgba(255, 193, 9, 0.426); }

    /* Hero */
    .hero{ position: relative; overflow: hidden; color: white;     padding: 12px 0px 3px; }
    .heroBg{
      position:absolute; inset:0;
      background:
        radial-gradient(1200px 600px at 20% 40%, rgba(255,255,255,0.18), transparent 60%),
        radial-gradient(900px 500px at 85% 30%, rgba(20,200,182,0.20), transparent 55%),
        linear-gradient(160deg, var(--bgTop), var(--bgMid));
    }

    .heroInner{
      position: relative;
      display: grid;
      grid-template-columns: 1fr;
      gap: 2px;
      align-items: center;
    }

    .heroTop{ 
      display: grid;
        text-align: left;
        align-self: start;
    }
    .heroLatestReportBadgeWrap {
      display: none;
    }



    .regtrade {
      font-size: 0.25em;
      vertical-align:top;
      color:#016faf;
      filter: none;
      font-weight: normal;
              margin-right: -10px;
      
    }


    .brandEm{ 
      color: #005d97;
        white-space: nowrap;
        /* filter: drop-shadow(1px 1px 1px rgba(255, 255, 255, 0.562)); */
        font-size: clamp(40px, 2.4vw, 34px);
        margin-top: -10px;
    }

    .brand_small {
              font-size: 0.5em;
        color: #005d97;
        
        font-weight: 700;
        letter-spacing: -0.6px;
        margin-left: 3px;
    }

    .personaImg{
      width: min(90%);
      height: auto;
      display: block;
      padding: 0;
      
      user-select: none;
      pointer-events: none;
    }

.faqPage {
  padding: 0 10px;
  max-width: 700px;
  margin: 0 auto;
}

.faqPage__title {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
}

.faqPage__subtitle {
  text-align: center;
  margin-bottom: 10px;
  color: #666;
}

.faqPage__section {
  margin-bottom: 10px;
  width: 546px;
  justify-self: center;
}

.faqPage__sectionTitle {
  font-size: 24px;
  margin-bottom: 10px;
  margin-top: 30px;
}

.faqPage__card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
  background: #fff;
}

.faqPage__questionRow {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.faqPage__question {
  font-size: 16px;
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: 5px;
}

.faqPage__answer {
  margin-top: 10px;
  color: #444;
  line-height: 1.6;
}

.faqPage__icon {
  font-size: 20px;
  margin-top: 0;
}

.faqPage__cta {
  margin-top: 30px;
  padding: 20px;
  text-align: center;
  background: #f3f4f6;
  border-radius: 12px;
  max-width: 400px;
  justify-self: center;
}

.faqPage__ctaTitle {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: -4px;
  margin-top: -2px;
}

.faqPage__button {
  margin-top: 10px;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  background: #4f46e5;
  color: #fff;
  cursor: pointer;
  font-weight: 600;
}

    .formRow{ display:flex; align-items: stretch;padding-left: 5px; }

    .selectWrap{ 
      position: relative;
        flex: 1;
        width: 200px;
        margin-left: 4px;
        margin-right: 8px;
        width: 100%;
        max-width: 250px;
    }
    .heroForm input[type="text"],
    .heroForm input[name="zip"],
    .heroForm input#homepage-zip {
      width: 100%;
      height: 52px;
      border-radius: 14px;
      border: 1px solid rgba(13,27,42,0.10);
      padding: 0 16px;
      background: rgba(255,255,255,0.98);
      color: #132238;
      font-weight: 700;
      outline: none;
      box-shadow: 0 6px 16px rgba(15,23,42,0.16);
    }
    .heroForm input::placeholder {
      color: #9ca3af;
      font-weight: 500;
    }
    select{
      width: 100%;
      height: 52px;
      border-radius: 14px;
      border: 1px solid rgba(13,27,42,0.10);
      padding: 0 44px 0 16px;
      background: rgba(255,255,255,0.95);
      color: #132238;
      font-weight: 700;
      outline: none;
    }

    /* Financing widget layout */
    .financing-widget-card{
                   background: #ffffff;
        border-radius: 20px;
        box-shadow: var(--shadowSoft);
        padding: 1px 7px 6px;
        margin: 5px 15px;
        margin-bottom: 25px;
        width: 75%;
        justify-self: center;
    }

    .financing-widget-title{
      font-size: 24px;
      margin: 6px 0 4px;
    }

    .financing-widget-subtitle{
      margin: 0 0 16px;
      color: #4b5563;
      font-size: 14px;
    }

    .financing-widget-layout{
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    .financing-widget-left,
    .financing-widget-right{
      width: 100%;
    }

    .financing-widget-grid{
      display: grid;
      grid-template-columns: 1fr;
      gap: 12px;
      margin-bottom: 16px;
    }

    .financing-widget-field label{
      display: block;
      font-weight: 600;
      margin-bottom: 4px;
      font-size: 13px;
    }

    .financing-widget-field input,
    .financing-widget-field select{
      width: 100%;
      padding: 10px 12px;
      border-radius: 10px;
      border: 1px solid #d1d5db;
      font-size: 14px;
    }

    .financing-widget-field input:focus,
    .financing-widget-field select:focus{
      outline: none;
      border-color: #2563eb;
      box-shadow: 0 0 0 1px rgba(37,99,235,0.25);
    }

    .financing-widget-calc{
      margin-top: 8px;
      padding: 10px 16px;
      border-radius: 999px;
      border: none;
      background: #016faf;
      color: #ffffff;
      font-weight: 700;
      cursor: pointer;
    }

    .financing-widget-calc:disabled{
      opacity: 0.6;
      cursor: default;
    }

    .financing-widget-actions--left{
      margin-top: 14px;
    }

    .financing-widget-results{
      display: flex;
      gap: 16px;
      margin-top: 16px;
    }

    .financing-widget-amount{
      flex: 1;
      text-align: left;
    }

    .financing-widget-amount .label{
      font-size: 12px;
      color: #6b7280;
      margin-bottom: 2px;
    }

    .financing-widget-amount .value{
      font-size: 18px;
      font-weight: 700;
    }

    .financing-widget-error{
      color: #dc2626;
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    .financing-widget-disclaimer{
              margin-top: 16px;
        font-size: 11px;
        color: #6b7280;
        justify-self: center;
        text-align: center;
    }

    .financing-widget-ai{
      padding: 12px 14px;
      border-radius: 16px;
      background: #f9fafb;
      border: 1px solid #e5e7eb;
    }

    .financing-widget-ai-header{
      display: grid;
      grid-template-columns: auto minmax(0, 1fr);
      align-items: start;
      gap: 14px;
      margin-bottom: 8px;
    }

    .financing-widget-ai-badge{
      grid-column: 1;
      grid-row: 1;
    }

    .financing-widget-ai-heading{
      grid-column: 2;
      grid-row: 1;
      min-width: 0;
      align-self: center;
    }

    .financing-widget-ai-badge .hh-badge-image{
      max-width: 120px;
      height: auto;
      display: block;
    }

    .financing-widget-ai-heading h3{
      margin: 0 0 4px;
    }

    .financing-widget-ai h3{
      margin: 13px 0 8px;
      font-size: 21px;
    }

    .financing-widget-ai-placeholder{
      grid-column: 1 / -1;
      margin: 2px 0 0;
      width: 100%;
      color: #374151;
      font-size: 14px;
      line-height: 1.5;
    }

    .financing-widget-ai-box{
      min-height: 8px;
      font-size: 14px;
      color: #374151;
    }

    .financing-widget-cta{
      margin-top: 16px;
      padding: 10px 16px;
      border-radius: 999px;
      border: none;
      background: #10b981;
      color: #ffffff;
      font-weight: 700;
      cursor: pointer;
    }

    @media (min-width: 551px){
      .financing-widget-card{
        max-width: 620px;
            padding: 7px 15px 10px 19px;
            justify-self: center;
      }

      .financing-widget-layout{
        flex-direction: row;
        justify-content: left;
        align-items: flex-start;
      }

      .financing-widget-left{
        flex: 0 0 30%;
        max-width: 360px;
      }

      .financing-widget-right{
        flex: 0 0 66%;
        max-width: 720px;
      }
    }

    @media (max-width: 550px){
      .financing-widget-left-submitted{
        display: none;
      }

    }
    .selectChevron{
      position:absolute; right: 14px; top: 50%;
      transform: translateY(-50%);
      color: rgba(19,34,56,0.55);
      font-size: 18px;
      pointer-events:none;
    }
    .ctaBtn{
      height: 52px;
      padding: 0 18px;
      border-radius: 14px;
      border: none;
      background: linear-gradient(180deg, #016faf 100%, #bebec4,100%, #a7abc0);
      color: white;
      font-weight: 900;
      z-index: 10000;
      /*box-shadow: 0 14px 30px rgba(34, 0, 255, 0.35);*/
      cursor: pointer;
      white-space: nowrap;
      min-width: 70px;
      width:140px;
    }
    .ctaBtn:disabled{ 
      opacity: 0.55; 
      cursor: not-allowed; 
      box-shadow: none; 
      background: linear-gradient(180deg, #016faf 100%, #016faf,100%, #0026ff);
    }
    .heroFinePrint{ 
      font-weight: 500; 
      color: rgba(255,255,255);
      padding-left: 12px; 
      font-size: 13px;
      letter-spacing: .02em;
      margin-top: 10px;
    }


    /* Projects */
    .projects{ 
      justify-self: center;
      
      
    }
  
    .projectCard{
      appearance: none;
      border: 1px solid rgba(13,27,42,0.10);
      background: white;
      border-radius: 22px;
      padding: 0px 0px 23px 0px;
      box-shadow: var(--shadowSoft);
      cursor:pointer;
      transition: transform .12s ease, box-shadow .12s ease;
      text-align: center;
    }
    .projectCard:hover{ transform: translateY(-2px); box-shadow: 0 18px 38px rgba(13,27,42,0.14); }
    .projectIcon{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto -7px
    }

    .projectIcon img{
      width: 92px;
      height: 92px;
      object-fit: cover;
      display: block;
    }

    .projectTitle{
      margin-top: 0;
        font-weight: 900;
        color: #0075cfd9;
        line-height: 1.15;
        white-space: pre-line;
        width: 190px;
        justify-self: center;
        font-size: clamp(12px, 2.5vw, 20px);
    }


    /* Footer */
    .footer{ padding: 22px 0 34px; background: #F6F8FC; }
    .footerInner{
      display:flex; justify-content:center; gap: 1px;
      font-weight: 700;
    }
    .footerInner a{ text-decoration: underline; text-underline-offset: 3px; }
    .footerDot{ opacity: 0.6; }

    /* A11y */
    .srOnly{
      position:absolute!important;
      width:1px;height:1px;
      padding:0;margin:-1px;
      overflow:hidden;clip:rect(0,0,0,0);
      white-space:nowrap;border:0;
    }


    .room-idea-results {
      max-width: 1200px;
      margin: 0 auto;
    }

    .image-collage {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
      gap: 16px;
      margin-top: 24px;
    }


    .collage-item {
      border-radius: 12px;
      overflow: hidden;
      background: #f5f5f5;
    }

    .collage-item img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.3s ease;
    }

    .collage-item:hover img {
      transform: scale(1.05);
    }

}


/*
******************************
  Desktop Desktop Desktop   
******************************
/*  981px and up 
*/

@media (min-width: 551px){


    .heroTitle{
      font-size: clamp(32px, 2.2vw, 46px);
      line-height: 1.05;
      font-weight: 700;
      letter-spacing: 2px;
      text-shadow: 0 10px 28px rgba(13,27,42,0.22);
      padding-left: 15px;
      margin-top: 30px;
      
    }

  .logoImage {
        width: 44px;
        height: auto;
        aspect-ratio: auto;
        max-width: 44px;
        flex: 0 0 auto;
        border-radius: 10px;
        display: block;
        object-fit: contain;
        margin-left: 3px;
        margin-right: 3px;
      }

.projectsGrid{ 
  display:grid; grid-template-columns: repeat(5, 1fr); gap: 5px;
width: 477px; }
    
  .projectsTitle{
      margin: 26px 0 12px;
      text-align: center;
      font-size: 22px;
      letter-spacing: -0.8px;
      font-weight: 700;
    }
.projectCardTitle{
      margin-top: 0;
        font-weight: 900;
        color: #0075cfd9;
        line-height: 1.15;
        white-space: pre-line;
        width: 80%;
        justify-self: center;
                font-size: clamp(10px, 3.1vw, 16px);
      }

    .heroQuestion{
      font-size: clamp(16px, 1.0vw, 46px);
      line-height: 1.05;
      font-weight: 700;
      letter-spacing: 0.03em;
      margin-left:10px;
      padding-bottom:10px;
      
      
    }
    .heroByline{
      margin: 0;
      padding-bottom: 4px;
      padding-top: 5px;
      font-size: 21px;
      line-height: 1.15;
      font-weight: 500;
      letter-spacing: -0.1px;
      margin-left: 15px;
    }

  .homepageCalculatorWrap {
            margin-bottom: 69px;
        width: 89%;
        border: 1px solid rgba(13, 27, 42, 0.10);
        border-radius: 22px;
        box-shadow: var(--shadowSoft);
        justify-self: center;
  }
  .homepageLatestReportBadgeWrap {
    width: 255px;
    max-width: 91%;
    margin: 4px auto 14px;
    display: flex;
    justify-content: center;
  }
  .homepageLatestReportBadgeWrap--sectionTop {
    width: 100%;
    max-width: 477px;
    margin: 8px auto 10px;
    justify-content: flex-end;
  }
  .homepageLatestReportBadgeWrap .latestReportBadge {
    width: 100%;
    justify-content: space-between;
  }
  .homepageLatestReportBadgeWrap--sectionTop .latestReportBadge {
    width: auto;
    min-width: 220px;
    max-width: 100%;
  }
   .browseProvidersBtn {
      width: 180px;
      justify-self: center;
      height: 52px;
      border-radius: 14px;
      border: none;
      background: linear-gradient(180deg, #016faf 100%, #bebec4,100%, #a7abc0);
      color: white;
      font-weight: 900;
      z-index: 10000;
      /*box-shadow: 0 14px 30px rgba(34, 0, 255, 0.35);*/
      cursor: pointer;
      white-space: nowrap;
      min-width: 205px;
    }
    
    .propertyReportCTA  { 
        width: 255px;
        cursor: pointer;
        transition: transform .12s ease, box-shadow .12s ease;
        text-align: center;
        max-width: 91%;
        margin-top: 25px;
        justify-self: center;
    }

    .crossSiteProjectSelector {
      width: 255px;
      max-width: 91%;
      margin: 25px auto 8px;
      min-height: 316px;
      padding: 16px 14px 18px;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 9px;
      border: 1px solid rgba(226, 232, 240, 0.9);
      background:
        radial-gradient(130px 90px at 80% 10%, rgba(255, 255, 255, 0.78), transparent 70%),
        radial-gradient(160px 110px at 18% 22%, rgba(255, 255, 255, 0.62), transparent 72%),
        linear-gradient(160deg, #dff3ff 0%, #7fc8f1 48%, #016faf 100%);
      border-radius: 24px;
      box-shadow: 0 18px 34px rgba(13, 27, 42, 0.16);
      text-align: left;
      isolation: isolate;
      cursor: pointer;
    }

    .crossSiteProjectSelector::before {
      content: "";
      position: absolute;
      inset: 0;
      background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(13, 27, 42, 0.22)),
        radial-gradient(220px 100px at 50% 110%, rgba(255, 255, 255, 0.44), transparent 72%);
      z-index: -1;
    }

    .crossSiteProjectSelectorMascot {
      position: relative;
      right: auto;
      top: auto;
      width: min(128px, 76%);
      max-width: none;
      height: auto;
      pointer-events: none;
      user-select: none;
      opacity: 0.94;
      filter: drop-shadow(0 12px 18px rgba(13, 27, 42, 0.22));
      z-index: 1;
      margin: -2px auto -1px;
    }

    .crossSiteProjectSelectorContent {
      position: relative;
      z-index: 1;
      width: 100%;
      margin-top: 0;
      text-align: center;
    }

    .crossSiteProjectSelectorEyebrow {
      display: inline-flex;
      align-items: center;
      min-height: 24px;
      justify-content: center;
      width: fit-content;
      max-width: calc(100% - 20px);
      padding: 5px 9px;
      margin: 0 auto 9px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.76);
      color: #005d97;
      font-size: 9px;
      line-height: 1;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: 0.08em;
      white-space: nowrap;
    }

    .crossSiteProjectSelectorLabel {
      display: block;
      margin: 0 auto 8px;
      max-width: 168px;
      font-size: 21px;
      line-height: 0.98;
      font-weight: 900;
      color: #ffffff;
      text-shadow: 0 2px 8px rgba(13, 27, 42, 0.28);
    }

    .crossSiteProjectSelectorCopy {
      margin: 0 auto 13px;
      max-width: 152px;
      color: rgba(255, 255, 255, 0.94);
      font-size: 11px;
      line-height: 1.22;
      font-weight: 750;
      text-shadow: 0 1px 7px rgba(13, 27, 42, 0.28);
    }

    .crossSiteProjectSelectorSelect {
      width: 100%;
      min-height: 46px;
      border-radius: 14px;
      border: 1px solid rgba(13, 27, 42, 0.24);
      background: #ffffff;
      color: var(--ink);
      font-weight: 800;
      padding: 0 12px;
      cursor: pointer;
      position: relative;
      z-index: 1;
      box-shadow: 0 10px 22px rgba(13, 27, 42, 0.16);
    }

    .crossSiteProjectSelector--home-helper {
      background:
        radial-gradient(140px 96px at 78% 8%, rgba(255, 255, 255, 0.82), transparent 70%),
        radial-gradient(150px 108px at 12% 18%, rgba(255, 255, 255, 0.58), transparent 72%),
        linear-gradient(158deg, #dff3ff 0%, #58bde8 46%, #016faf 100%);
    }

    .crossSiteProjectSelector--house-helper {
      background:
        radial-gradient(150px 98px at 76% 8%, rgba(255, 255, 255, 0.78), transparent 70%),
        radial-gradient(140px 104px at 12% 18%, rgba(244, 196, 48, 0.38), transparent 72%),
        linear-gradient(158deg, #c8efad 0%, #7cc243 42%, #2f7d32 100%);
        border-color: #bebfc1;
    }

    .crossSiteProjectSelector--house-helper .crossSiteProjectSelectorEyebrow {
      color: #1b5e20;
    }
    
   .browseProvidersCTA   {
      margin-bottom: 15px;
        width: 255px;
        /* display: grid; */
        /* appearance: none; */
        border: 1px solid rgba(13, 27, 42, 0.10);
        background: white;
        border-radius: 22px;
        padding: 0px 0px 23px 0px;
        box-shadow: var(--shadowSoft);
        cursor: pointer;
        transition: transform .12s ease, box-shadow .12s ease;
        text-align: center;
        max-width: 91%;
        margin-top: 5px;
        justify-self: center;
    }

   .browseProvidersHeader{
              margin: 12px 1px 12px;
        text-align: center;
        font-size: 17px;
        letter-spacing: -0.6px;
        font-weight: 700;
    }

   
    .browseProvidersbyline {
      margin: 0 0 12px;
      text-align: center;
      font-size: 15px;
      letter-spacing: -0.6px;
      font-weight: 300;
      width: 254px;
      justify-self: center;
    }
    

     .browseProvidersbyline{
      margin: 0 0 12px;
      text-align: center;
      font-size: 15px;
      letter-spacing: -0.6px;
      font-weight: 300;
      width: 90%;
    }
    
    .browseProvidersInput{
             margin-bottom: 12px;
        /* margin-left: 25px; */
        /* align-items: center; */
        font-size: 18px;
        letter-spacing: -0.6px;
        font-weight: 300;
        width: 173px;
        height: 44px;
        text-align: center;
    }
    .browseProvidersSelect{
      margin-bottom: 12px;
        letter-spacing: -0.6px;
        font-weight: 600;
        width: 180px;
    } 
    
  .toolgrid-template {
      display: grid;
      grid-template-columns: repeat(2, minmax(220px, 1fr));
      gap: -15px;
      padding: 69px;
      padding-top:0px;
      padding-bottom: 0px;
  }

  .toolsGrid-bubble {
    border-radius: 12px;
        padding: 16px 12px;
        border: 1px solid #3690ffa2;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 42px;
        margin-top: 15px;
  }
  .heroInner{
    grid-template-columns: 0.5fr 1.45fr; 
        grid-template-areas:
        "left top"
        "left bottom";
        row-gap: 24px;
        
  }

  .heroLeft{
    max-width: 350px;
  }

  .projectsGrid{ grid-template-columns: repeat(3, 1fr); }  
  

  .heroTop{
    grid-area: top;
    text-align: left;
    align-self: start;
  }

  .heroBottom {
    color: rgb(255, 255, 255);
    margin-top: -14px;
    margin-bottom: 15px;
    font-size: 13px;
    font-size: 16px;
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.2));
    max-width: 674px;
    justify-self: center;
    
  }

    

    /* Bigger than mobile, smaller than desktop */
    .personaImg{
      width: 172px;
      margin-left: 23px;
    }

    .heroForm{
    max-width: 451px;
    margin-left:10px;
    background: rgba(255,255,255,0.10);
    border: 1px solid rgba(255,255,255,0.18);
    border-radius: var(--radiusLg);
    padding: 10px;
    box-shadow: var(--shadow);
    margin-top: 11px;
    margin-right: 15px;
    }

 

  .textShadowSolid {
    text-shadow:
      .5px 0 0 #979696,
      .5px 0 0 #979696,
      .5px 1px 0 #979696,
      0 0 0 #979696;
  }
  .tool-page {
    width: 100%;
  }

  .tool-page-inner {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0px 2rem 1.25rem;
  }

  .tool-page-header {
    margin-bottom: 2rem;
  }

  .tool-page-title {
    margin: 0;
  }

  .tool-page-description {
    max-width: 720px;
  }


  /* Service Providers directory */
  .providersPage {
            background: #f3f4f6;
        min-height: 100vh;
        padding: 24px 0 40px;
        max-width: 730px;
        justify-self: center;
  }

  .providersHeader {
    margin-bottom: 8px;
  }

  .providersHeader-inner {
    max-width: 1080px;
    margin: 0 auto;
    padding: 0 16px;
  }

  .providersTitle {
    margin: 0 0 4px;
    font-size: 26px;
    font-weight: 700;
    color: #0f172a;
  }

  .providersSubtitle {
    margin: 0 0 16px;
    font-size: 14px;
    color: #4b5563;
  }

  .providersSearchCard {
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
    padding: 16px 16px 18px;
    border: 1px solid rgba(15, 23, 42, 0.06);
  }

  .providersSearchGrid {
    display: grid;
    grid-template-columns: minmax(0, 2.1fr) minmax(0, 1fr) minmax(0, 2fr) auto;
    gap: 16px;
    align-items: flex-end;
  }

  .providersField {
    display: flex;
    flex-direction: column;
  }

  .providersField--compact {
    max-width: 180px;
  }

  .providersLabel {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 4px;
  }

  .providersInput,
  .providersSelect {
    width: 100%;
    height: 52px;
    border-radius: 14px;
    border: 1px solid rgba(13, 27, 42, 0.1);
    padding: 0 16px;
    font-size: 14px;
    line-height: 1.4;
    color: #132238;
    background-color: rgba(255, 255, 255, 0.98);
    font-weight: 700;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.16);
  }

  .providersInput::placeholder {
    color: #9ca3af;
    font-weight: 500;
  }

  .providersInput:focus,
  .providersSelect:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);
  }

  .providersHelpText {
    margin-top: 4px;
    font-size: 12px;
    color: #6b7280;
  }

  .providersActions {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }

  .providersSearchButton {
    min-width: 160px;
    height: 52px;
    padding: 0 18px;
    border-radius: 14px;
    border: none;
    background: linear-gradient(180deg, #016faf 100%, #bebec4 100%, #a7abc0);
    color: #ffffff;
    font-weight: 900;
    font-size: 14px;
    cursor: pointer;
  }

  .providersSearchButton:hover {
    background: linear-gradient(180deg, #0284c7, #005fa3);
  }

  .providersSearchButton:focus-visible {
    outline: 3px solid #f97316;
    outline-offset: 2px;
  }

  .providersResults {
    max-width: 1080px;
    margin: 18px auto 0;
    padding: 0 16px;
  }

  .providersStatus {
    text-align: center;
    color: #4b5563;
    font-size: 14px;
    padding: 24px 0;
  }

  .providersTableWrap {
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
    border: 1px solid rgba(15, 23, 42, 0.06);
    overflow-x: auto;
  }

  .providersTable {
    width: 100%;
    border-collapse: collapse;
  }

  .providersTable thead {
    background: #f3f4f6;
  }

  .providersTable th,
  .providersTable td {
    padding: 12px 20px;
    font-size: 14px;
    text-align: left;
  }

  .providersTable th {
    font-weight: 600;
    color: #111827;
    border-bottom: 1px solid #e5e7eb;
  }

  .providersTable tbody tr:nth-child(even) {
    background: #f9fafb;
  }

  .providersTable tbody tr {
    cursor: pointer;
    transition: background-color 0.12s ease, box-shadow 0.12s ease;
  }

  .providersTable tbody tr:hover {
    background-color: #e5f2ff;
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.12);
  }

  .providersCell-business {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .providersLogo {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    object-fit: cover;
    border: 1px solid #e5e7eb;
    background: #ffffff;
  }

  .providersBusinessName {
    font-weight: 600;
    color: #111827;
  }

  .providersPhone {
    font-size: 13px;
    color: #4b5563;
    margin-top: 2px;
  }

  .providersCell-description {
    max-width: 360px;
    color: #4b5563;
  }

  .providersCell-actions {
    text-align: right;
  }

  .providersProfileButton {
    padding: 8px 14px;
    border-radius: 999px;
    background: #2563eb;
    color: #ffffff;
    border: none;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }

  .providersProfileButton:hover {
    background: #1d4ed8;
  }

  .providersProfileButton:focus-visible {
    outline: 3px solid #f97316;
    outline-offset: 2px;
  }

  .providersTableActionsHeader {
    text-align: right;
  }

  .visuallyHidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  @media (max-width: 550px) {
    .providersPage {
      padding: 16px 0 28px;
    }

    .providersHeader-inner {
      padding: 0 12px;
      max-width: 100%;
    }

    .providersTitle {
      font-size: 22px;
      text-align: center;
    }

    .providersSubtitle {
      font-size: 13px;
      text-align: center;
    }

    .providersSearchCard {
      padding: 14px 12px 16px;
      margin-top: 10px;
    }

    .providersSearchGrid {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .providersField--compact {
      max-width: none;
    }

    .providersField {
      margin-bottom: 4px;
    }

    .providersActions {
      justify-content: stretch;
    }

    .providersSearchButton {
      width: 100%;
      min-width: 0;
    }

    .providersResults {
      padding: 0 12px;
    }

    .providersTable th,
    .providersTable td {
      padding: 10px 12px;
      font-size: 13px;
    }

    .providersCell-description {
      max-width: none;
    }

    .providersLogo {
      width: 40px;
      height: 40px;
    } 
  }


    /* Projects layout wrapper */
    .projectsLayout {
      display: grid;
      grid-template-columns: 1fr 0fr;
      width: 94%;
      margin-left: 20px;
    }



    /* Sidebar CTA */
    .projectsSidebar {
      position: sticky;
        top: -10px;
        width: 104%;
    }

    @media (min-width: 960px) {
      .projectsLayout {
        --projects-sidebar-width: 191.25px;
        display: grid;
        grid-template-columns: minmax(0, 1fr) var(--projects-sidebar-width);
        align-items: start;
        gap: clamp(24px, 2.5vw, 32px);
        width: min(100%, 1060px);
        margin: 0 auto;
      }

      .projectsMain {
        min-width: 0;
      }

      .projectsGrid {
        width: 100%;
        max-width: none;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
      }

      .projectCard {
        width: 100%;
      }

      .projectsSidebar {
        width: 100%;
        max-width: var(--projects-sidebar-width);
        justify-self: stretch;
        align-self: start;
        top: 0;
      }

      .projectsSidebar .crossSiteProjectSelector,
      .projectsSidebar .propertyReportCTA,
      .projectsSidebar .browseProvidersCTA,
      .projectsSidebar .homepageCalculatorWrap {
        width: 100%;
        max-width: none;
        margin-left: 0;
        margin-right: 0;
        justify-self: stretch;
        box-sizing: border-box;
      }

      .projectsSidebar .crossSiteProjectSelector {
        margin-top: 72px;
      }

      .projectsSidebar .propertyReportCTA {
        margin-top: 8px;
      }

      .projectsSidebar .homeReportCta,
      .projectsSidebar .homeReportCtaImage {
        display: block;
        width: 100%;
        max-width: 100%;
        height: auto;
      }

      .projectsSidebar .browseProvidersHeader,
      .projectsSidebar .browseProvidersbyline {
        width: auto;
      }

      .projectsSidebar .browseProvidersInput,
      .projectsSidebar .crossSiteProjectSelectorSelect,
      .projectsSidebar .browseProvidersSelect,
      .projectsSidebar .browseProvidersBtn {
        min-width: 0;
        max-width: none;
        box-sizing: border-box;
      }

      .projectsSidebar .browseProvidersInput,
      .projectsSidebar .browseProvidersSelect,
      .projectsSidebar .browseProvidersBtn {
        width: calc(100% - 32px);
      }

      .projectsSidebar .homepageCalculatorWrap {
        margin-bottom: 15px;
      }

      .projectsSidebar .homepageCalculatorWrap .calculator-card {
        width: 100%;
        max-width: none;
        margin-right: 0;
        box-sizing: border-box;
      }
    }


}


/* Service Providers directory (mobile overrides - active) */
@media (max-width: 550px) {
  .providersPage {
    padding: 16px 0 28px;
  }

  .providersHeader-inner {
    padding: 0 12px;
    max-width: 100%;
  }

  .providersTitle {
    font-size: 22px;
    text-align: center;
    margin: 0px;
  }

  .providersSubtitle {
            font-size: 13px;
        text-align: center;
        max-width: 276px;
        justify-self: center;
  }

  .providersSearchCard {
    padding: 14px 12px 16px;
    margin-top: 10px;
  }

  .providersSearchGrid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .providersField--compact {
    max-width: none;
  }

  .providersField {
    margin-bottom: 4px;
  }

  .providersInput,
  .providersSelect {
    width: 90%;
        height: 43px;
        margin: 5px 0px 5px 0px;
        border-radius: 14px;
        border: 1px solid rgba(13, 27, 42, 0.1);
        padding: 9px 12px;
        font-size: 14px;
        line-height: 1.4;
        color: #132238;
        background-color: rgba(255, 255, 255, 0.98);
        font-weight: 700;
        box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);
  }

  .providersInput::placeholder {
    color: #9ca3af;
    font-weight: 500;
  }

  .providersActions {
    justify-content: stretch;
  }

  .providersSearchButton {
    width: 100%;
    min-width: 0;
    height: 52px;
    padding: 0 18px;
    border-radius: 14px;
    border: none;
    background: linear-gradient(180deg, #016faf 100%, #bebec4 100%, #a7abc0);
    color: #ffffff;
    font-weight: 900;
    font-size: 14px;
    cursor: pointer;
  }

  .providersResults {
    padding: 0 12px;
  }

  .providersTable th,
  .providersTable td {
    padding: 5px 5px;
    font-size: 13px;
    
  }

  .providersCell-description {
    max-width: none;
  }

  .providersLogo {
    width: 40px;
        height: 40px;
        text-align: center;
        justify-self: center;
        display: block;
  }

  .providersBusinessName {
    font-size: 14px;
    text-align: center;
  }

   .providersPhone {
    font-size: 12px;
    color: #4b5563;
    margin-top: 2px;
    text-align: center;
  }
}



/* 
**************************************
  Mobile Mobile Mobile Mobile Mobile
**************************************
*/
   

@media (max-width: 550px){

  .brandEm{ 
      color: #005d97;
        white-space: nowrap;
        /* filter: drop-shadow(1px 1px 1px rgba(255, 255, 255, 0.562)); */
        font-size: clamp(40px, 2.4vw, 34px);
        margin-top: -10px;
        letter-spacing: 0.001em;
        margin-left: 10px;
    }
    
    .heroTitle{
      font-size: clamp(32px, 2.2vw, 46px);
      line-height: 1.05;
      font-weight: 700;
      letter-spacing: 2px;
      text-shadow: 0 10px 28px rgba(13,27,42,0.22);
      justify-self: center;
      
    }
  .logoImage {
        width: 44px;
        height: auto;
        aspect-ratio: auto;
        max-width: 44px;
        flex: 0 0 auto;
        border-radius: 10px;
        display: block;
        object-fit: contain;
        margin-left: 7px;
      }
 
.projectsGrid{ 
      display: inline-grid;
        grid-template-columns: repeat(2, 28fr);
        gap: 12px 0px;
        justify-self: center;  
        
      }
    
        .projectsTitle{
     margin: 10 0 12px; 
        font-size: clamp(20px, 3.1vw, 16px);
        font-weight: 700;
        text-align: center;
      
    }
.projectCardTitle{
      margin-top: -18px;
        font-weight: 900;
        color: #0075cfd9;
        line-height: 1.15;
        white-space: pre-line;
        width: 95%;
        justify-self: center;
        font-size: clamp(13px, 3.1vw, 16px);
        
      }
      
      
    .projectsSidebar {
     justify-self: center;
        align-self: center;
        width: 100%;
        display: flow;
        /* background-color: rgb(65, 160, 243); */
        margin-bottom: 20px;
    }


    .toolgrid-template {
    display: grid;
    grid-template-columns: repeat(1, minmax(220px, 1fr));
    gap: 20;
    
  }

.toolsGrid-bubble {
    border-radius: 12px;
    padding: 16px 12px;
    border: 1px solid #3690ffa2;
    display: "flex";
    flex-direction: "column";
    align-items: "center";
    margin: 12px;
  }

   .ctaBtn {
    margin: 8px auto;
    display: block;
  }
  .homepageCalculatorWrap {
               border-radius: 22px;
        box-shadow: var(--shadowSoft);
        transition: transform .12s ease, box-shadow .12s ease;
        /* text-align: center; */
        justify-self: center;
        max-width: 287px;
        margin: 20px;
  }
  .homepageLatestReportBadgeWrap {
    width: 100%;
    max-width: 287px;
    margin: 12px auto 0;
    display: flex;
    justify-content: center;
  }
  .homepageLatestReportBadgeWrap--sectionTop {
    max-width: 287px;
    margin: 10px auto 8px;
    justify-content: center;
    display: none;
  }
  .homepageLatestReportBadgeWrap .latestReportBadge {
    width: 100%;
    justify-content: space-between;
  }
  .homepageLatestReportBadgeWrap--sectionTop .latestReportBadge {
    width: 100%;
    min-width: 0;
  }

   .browseProvidersCTA   {
               width: 100%;
        text-align: center;
        /* appearance: none; */
        border: 1px solid rgba(13, 27, 42, 0.10);
        background: white;
        padding: 0px 0px 23px 0px;


        border-radius: 22px;
        box-shadow: var(--shadowSoft);
        transition: transform .12s ease, box-shadow .12s ease;
        /* text-align: center; */
        justify-self: center;
        max-width: 287px;
        margin: 20px;



    }

  .homeReportCta {
    display: block;
        margin: 10px auto 0;
        max-width: 362px;
  }

  .homeReportCtaImage {
    display: block;
    width: 73%;
    height: auto;
    justify-self: center;
  }

   .browseProvidersHeader{
      margin: 24px 0 12px;
      text-align: center;
      font-size: 20px;
      letter-spacing: -0.6px;
      font-weight: 700;
    }

      
    .browseProvidersInput{
      margin-bottom: 12px;
        font-size: 21px;
        letter-spacing: -0.6px;
        font-weight: 300;
        width: 218px;
        justify-self: center;
        text-align: center;
    }
    .browseProvidersSelect{
              margin-bottom: 12px;
        justify-self: center;
        font-size: 20px;
        letter-spacing: -0.6px;
        font-weight: 300;
        width: 247px;
        font-weight: 600;
    } 
    .browseProvidersbyline {
      margin: 0 0 12px;
      text-align: center;
      font-size: 15px;
      letter-spacing: -0.6px;
      font-weight: 300;
      width: 254px;
      justify-self: center;
    }
    .browseProvidersBtn {
      width: 180px;
      justify-self: center;
      height: 52px;
      border-radius: 14px;
      border: none;
      background: linear-gradient(180deg, #016faf 100%, #bebec4,100%, #a7abc0);
      color: white;
      font-weight: 900;
      z-index: 10000;
      /*box-shadow: 0 14px 30px rgba(34, 0, 255, 0.35);*/
      cursor: pointer;
      white-space: nowrap;
      min-width: 205px;
    }

     

  .dot{ font-weight: 900; color: #FF7A00; margin-left: -4px; }
  .container{ width: 100%; }
  .headerInner{
    padding: 8px 0;
    gap: 8px;
    align-items: center;
  }
  .homeLink{
    min-width: 0;
    flex: 1 1 auto;
  }
  .logo{
    width: 100%;
    min-width: 0;
    gap: 4px;
  }
  .logoImage{
    width: 38px;
    max-width: 38px;
    height: auto;
    margin-left: 4px;
    margin-right: 2px;
  }
  .logoText{
    padding-right: 0;
  }
  .brand{
    font-size: 26px;
    line-height: 0.95;
    white-space: nowrap;
  }
  .tagline{
    font-size: 9px;
    letter-spacing: 0.04em;
  }
  .contractorLink{ 
            text-align: center;
        padding: 2px 2px 2px 2px;
        justify-self: right;
        font-size: 11px;
        color: rgb(0, 166, 255);
        width: 79px;
        margin-right: 7px;
  }
  .heroForm {
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.22);
    box-shadow: var(--shadow);
    padding: 14px 12px;
    margin-top: 10px;
  }
  .heroLatestReportBadgeWrap {
            width: 100%;
        max-width: 143px;
        margin: 8px 8px 8px 8px;
        display: flex;
        justify-self: center;
        position: relative;
        z-index: 1;
  }
  .heroLatestReportBadgeWrap .latestReportBadge {
    width: 100%;
    justify-content: space-between;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(226, 243, 255, 0.94));
    box-shadow: 0 12px 24px rgba(7, 55, 112, 0.22);
  }
.heroBottom {
          margin-top: 15px;
        /* font-weight: 500; */
        color: rgb(255, 255, 255);
        letter-spacing: 0.01em;
        font-size: 12px;
        font-size: large;
        /* text-align: center; */
        /* width: 90%; */
        margin-left: 15px;
        z-index: 999;
        position: relative;
        display:none;
}
  .hero{ padding: 8px 0 6px; }
  .heroInner{ gap: 1px; }
  
 

    .heroQuestion{
      font-size: clamp(16px, 1.0vw, 46px);
      line-height: 1.05;
      font-weight: 700;
      letter-spacing: 0.03em;
      margin-left:10px;
      padding-bottom:10px;
      
      
    }
    .heroByline{
        margin-left: 15px;
        margin-right: 15px;
        padding-bottom: 4px;
        padding-top: 5px;
        font-size: 21px;
        justify-self: center;
        text-align: center;
    }

  .heroFinePrint{ 
    font-weight: 500;
        color: rgba(255, 255, 255);
        padding-left: 12px;
        font-size: 13px;
        letter-spacing: .02em;
        margin-top: 1px;
        margin-bottom: 8px;
  }


  .heroLeft {
    display: flex;
    justify-content: center;
  }

  .personaBlock {
    margin: 0;
    height: 180px;
  }

  .personaImg {
    width: auto;
    max-width: 160px;
    max-height: 180px;
    height: auto;
    object-fit: contain;
  }
  

 
  .heroQuestion{
            font-size: clamp(17px, 2.0vw, 46px);
        color: #ffffff;
        line-height: 1.05;
        font-weight: 700;
        letter-spacing: -.02em;
        margin-top: 6px;
        margin-bottom: 1px;
        text-align: center;
  
  } 

  .heroForm{ 
    padding: 2px;
        border-radius: 20px;
        /* margin-top: 5px; */
        text-align: center;
        width: 93%; 
        justify-self: center;
  }
  .formRow{ 
    flex-wrap: wrap;
    flex-direction: column; 
    text-align: center; 
    align-content: center;
  }
  .ctaBtn{ width:180px; min-width: 0; text-align: center; align-content: center}

 
  .projectCard{ 
            max-width: 400px;
        width: 95%;
        justify-self: center;
  }
  

  
}


@media (max-width: 375px) {
    .logoImage {
        width: 34px;
        max-width: 34px;
    }
    .brand {
        font-size: 22px;
    }
    .tagline {
        font-size: 8px;
    }
}
    

@media (max-width: 330px) {
    .brand {
        font-size: 17px;
    }
}
    

 @media (max-width: 550px){
      .financing-widget-left-submitted{
        display: none;
      }

      .financing-widget-disclaimer {
          margin-top: 10px;
          font-size: 12px;
          color: #6b7280;
          width: 80%;
          justify-self: center;
          text-align: center;
      }
    }

html[data-brand="house-helper"] .page {
  background: #fbfdf8;
}

html[data-brand="house-helper"] .header {
  background: rgba(255, 255, 255, 0.78);
  border-bottom-color: rgba(47, 125, 50, 0.18);
}

html[data-brand="house-helper"] .logo {
  color: #17351c;
}

html[data-brand="house-helper"] .logoMark {
  color: var(--brandAccent);
  border-color: rgba(47, 125, 50, 0.18);
  box-shadow: 0 10px 24px rgba(47, 125, 50, 0.14);
}

html[data-brand="house-helper"] .brand,
html[data-brand="house-helper"] .brandEm,
html[data-brand="house-helper"] .brand_small,
html[data-brand="house-helper"] .regtrade {
  color: var(--brandPrimaryDark);
}

html[data-brand="house-helper"] .dot {
  color: var(--brandAccent);
}

html[data-brand="house-helper"] .tagline,
html[data-brand="house-helper"] .contractorLink {
  color: #285c31;
}

html[data-brand="house-helper"] .contractorLink {
  border-color: rgba(47, 125, 50, 0.24);
  background: rgba(237, 248, 231, 0.72);
}

html[data-brand="house-helper"] .contractorLink:hover {
  background: rgba(244, 196, 48, 0.28);
}

html[data-brand="house-helper"] .heroBg {
  background:
    radial-gradient(1000px 520px at 14% 24%, rgba(255, 255, 255, 0.26), transparent 58%),
    radial-gradient(760px 460px at 86% 28%, rgba(244, 196, 48, 0.22), transparent 54%),
    linear-gradient(160deg, var(--bgTop), var(--bgMid));
}

html[data-brand="house-helper"] .heroForm {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.28);
  box-shadow: 0 12px 28px rgba(24, 83, 33, 0.2);
}

html[data-brand="house-helper"] .ctaBtn,
html[data-brand="house-helper"] .browseProvidersBtn,
html[data-brand="house-helper"] .providersSearchButton,
html[data-brand="house-helper"] .provider-cta-button,
html[data-brand="house-helper"] .provider-request-button,
html[data-brand="house-helper"] .faqPage__button,
html[data-brand="house-helper"] .financing-widget-calc {
  background: linear-gradient(180deg, var(--brandPrimaryBright), var(--brandPrimary));
  color: #ffffff;
  box-shadow: 0 12px 24px rgba(47, 125, 50, 0.22);
}

html[data-brand="house-helper"] .ctaBtn:hover,
html[data-brand="house-helper"] .browseProvidersBtn:hover,
html[data-brand="house-helper"] .providersSearchButton:hover,
html[data-brand="house-helper"] .provider-cta-button:hover,
html[data-brand="house-helper"] .provider-request-button:hover,
html[data-brand="house-helper"] .faqPage__button:hover,
html[data-brand="house-helper"] .financing-widget-calc:hover {
  background: linear-gradient(180deg, #66aa36, var(--brandPrimaryDark));
}

html[data-brand="house-helper"] .ctaBtn:disabled {
  background: linear-gradient(180deg, #94bd83, #5f8f5f);
}

html[data-brand="house-helper"] .projectCard,
html[data-brand="house-helper"] .crossSiteProjectSelector,
html[data-brand="house-helper"] .browseProvidersCTA,
html[data-brand="house-helper"] .providersSearchCard,
html[data-brand="house-helper"] .providersTableWrap,
html[data-brand="house-helper"] .provider-table-card,
html[data-brand="house-helper"] .provider-gallery-card,
html[data-brand="house-helper"] .provider-photo-card,
html[data-brand="house-helper"] .provider-cta-card {
  border-color: #bebfc1;
  box-shadow: var(--shadowSoft);
}

html[data-brand="house-helper"] .projectCard:hover {
  box-shadow: 0 18px 38px rgba(24, 83, 33, 0.16);
}

html[data-brand="house-helper"] .projectTitle,
html[data-brand="house-helper"] .projectCardTitle,
html[data-brand="house-helper"] .browseProvidersHeader {
  color: var(--brandPrimary);
}

html[data-brand="house-helper"] .crossSiteProjectSelectorLabel {
  color: #ffffff;
}

html[data-brand="house-helper"] .toolsGrid-bubble {
  border-color: rgba(124, 194, 67, 0.5);
  background: linear-gradient(180deg, rgba(237, 248, 231, 0.72), rgba(255, 255, 255, 0.96));
}

html[data-brand="house-helper"] .providersPage {
  background: #f3f8ef;
}

html[data-brand="house-helper"] .providersInput:focus,
html[data-brand="house-helper"] .providersSelect:focus,
html[data-brand="house-helper"] .financing-widget-field input:focus,
html[data-brand="house-helper"] .financing-widget-field select:focus {
  border-color: var(--brandPrimary);
  box-shadow: 0 0 0 2px rgba(47, 125, 50, 0.22);
}

html[data-brand="house-helper"] .providersTable thead,
html[data-brand="house-helper"] .providersTable tbody tr:hover {
  background: var(--brandPrimarySoft);
}

html[data-brand="house-helper"] .providersProfileButton {
  background: var(--brandPrimary);
}

html[data-brand="house-helper"] .providersProfileButton:hover {
  background: var(--brandPrimaryDark);
}

html[data-brand="house-helper"] .provider-hero {
  background: linear-gradient(135deg, var(--brandPrimaryDark), var(--brandPrimaryBright));
}

@media (max-width: 550px) {
  .projects .container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  .projectsLayout {
    display: block;
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 0 14px 20px;
  }

  .projectsMain {
    width: 100%;
    min-width: 0;
  }

  .projectsGrid,
  .projectsGrid.projectsGrid--twoCol {
    display: grid;
    width: 100%;
    max-width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    justify-self: auto;
  }

  .projectCard {
    width: 100%;
    max-width: none;
    min-width: 0;
    min-height: 156px;
    padding: 12px 8px 16px;
    border-radius: 18px;
  }

  .projectIcon img {
    width: 84px;
    height: 84px;
    object-fit: contain;
  }

  .projectCardTitle {
    width: 100%;
    margin-top: -8px;
    font-size: 15px;
    line-height: 1.12;
    overflow-wrap: anywhere;
  }

  .projectsSidebar {
    position: static;
    top: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 100%;
    margin: 18px auto 0;
  }

  .projectsSidebar .crossSiteProjectSelector {
    width: 100%;
    max-width: 330px;
    min-height: 214px;
    margin: 0 auto 12px;
    padding: 16px 14px 18px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    overflow: hidden;
    isolation: isolate;
    border: 1px solid rgba(226, 232, 240, 0.9);
    border-radius: 22px;
    background:
      radial-gradient(130px 90px at 82% 10%, rgba(255, 255, 255, 0.78), transparent 70%),
      linear-gradient(160deg, #dff3ff 0%, #64bee8 45%, #016faf 100%);
    box-shadow: 0 16px 32px rgba(13, 27, 42, 0.14);
    color: #ffffff;
    cursor: pointer;
  }

  .projectsSidebar .crossSiteProjectSelector::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(13, 27, 42, 0.22)),
      radial-gradient(220px 100px at 50% 110%, rgba(255, 255, 255, 0.42), transparent 72%);
  }

  .projectsSidebar .crossSiteProjectSelector--house-helper {
    background:
      radial-gradient(130px 90px at 82% 10%, rgba(255, 255, 255, 0.78), transparent 70%),
      linear-gradient(160deg, #c8efad 0%, #7cc243 42%, #2f7d32 100%);
  }

  .projectsSidebar .crossSiteProjectSelector--home-helper {
    background:
      radial-gradient(130px 90px at 82% 10%, rgba(255, 255, 255, 0.78), transparent 70%),
      linear-gradient(160deg, #dff3ff 0%, #64bee8 45%, #016faf 100%);
  }

  .projectsSidebar .crossSiteProjectSelectorMascot {
    position: absolute;
    right: -10px;
    top: 8px;
    width: 94px;
    height: auto;
    max-width: none;
  }

  .projectsSidebar .crossSiteProjectSelectorContent {
    width: min(100%, 190px);
    position: relative;
    z-index: 1;
  }

  .projectsSidebar .crossSiteProjectSelectorEyebrow {
    display: inline-flex;
    align-items: center;
    min-height: 24px;
    padding: 4px 8px;
    margin: 0 0 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.78);
    color: #005d97;
    font-size: 10px;
    line-height: 1;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .projectsSidebar .crossSiteProjectSelector--house-helper .crossSiteProjectSelectorEyebrow {
    color: #1b5e20;
  }

  .projectsSidebar .crossSiteProjectSelectorLabel {
    font-size: 21px;
    line-height: 1.04;
    display: block;
    margin: 0 0 7px;
    color: #ffffff;
    font-weight: 900;
    text-shadow: 0 2px 8px rgba(13, 27, 42, 0.28);
  }

  .projectsSidebar .crossSiteProjectSelectorCopy {
    max-width: 190px;
    font-size: 12px;
    margin: 0 0 12px;
    color: rgba(255, 255, 255, 0.94);
    line-height: 1.22;
    font-weight: 750;
    text-shadow: 0 1px 7px rgba(13, 27, 42, 0.28);
  }

  .projectsSidebar .crossSiteProjectSelectorSelect {
    width: 100%;
    max-width: none;
    min-height: 46px;
    position: relative;
    z-index: 1;
    border-radius: 14px;
    border: 1px solid rgba(13, 27, 42, 0.24);
    background: #ffffff;
    color: var(--ink);
    font-weight: 800;
    padding: 0 12px;
    box-shadow: 0 10px 22px rgba(13, 27, 42, 0.16);
  }

  .projectsSidebar .propertyReportCTA,
  .projectsSidebar .browseProvidersCTA,
  .projectsSidebar .homepageCalculatorWrap {
    width: 100%;
    max-width: 330px;
    margin-left: auto;
    margin-right: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,2CAA2C;EAC3C,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,gDAAgD;EAChD,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;;AAGA,GAAG,sBAAsB,EAAE;AAC3B,YAAY,WAAW,EAAE;AACzB,MAAM,QAAQ,EAAE,6EAA6E,EAAE,iBAAiB,EAAE;AAClH,GAAG,cAAc,EAAE,qBAAqB,EAAE;AAC1C,gBAAgB,aAAa,EAAE;;AAE/B,OAAO,gBAAgB,EAAE,mBAAmB,EAAE;AAC9C,YAAY,YAAY;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;+BAE+B;;AAE/B;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE;IACE,kBAAkB;EACpB;;;EAGA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;;AAGA,6BAA6B;AAC7B;;IAEI,WAAW;IACX;MACE,gBAAgB,EAAE,MAAM,EAAE,WAAW;MACrC,kCAAkC;MAClC,2BAA2B;MAC3B,mDAAmD;IACrD;IACA;MACE,YAAY,EAAE,kBAAkB,EAAE,6BAA6B;MAC/D,eAAe;IACjB;;;IAGA,OAAO,YAAY,EAAE,kBAAkB,EAAE,QAAQ,GAAG,cAAc,EAAE,YAAY,EAAE;IAClF;MACE,oBAAoB;MACpB,mBAAmB;MACnB,YAAY;MACZ,cAAc;IAChB;IACA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,qCAAqC;QACrC,aAAa;QACb,mBAAmB;QACnB,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;QACjB,sCAAsC;;IAE1C;IACA,eAAe,WAAW,EAAE,YAAY,KAAK,gBAAgB,EAAE;IAC/D,WAAW,gBAAgB,CAAC,mBAAmB,EAAE,YAAY,EAAE;IAC/D,QAAQ,gBAAgB,EAAE,eAAe,EAAE,sBAAsB,EAAE,cAAc,EAAE;IACnF,MAAM,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;IAC3D;cACU,eAAe;QACrB,qBAAqB;QACrB,gBAAgB;QAChB,aAAa;QACb,eAAe;KAClB;;IAED;MACE,gBAAgB,EAAE,6BAA6B;MAC/C,kBAAkB,EAAE,oBAAoB;MACxC,wCAAwC;MACxC,+BAA+B;MAC/B,sBAAsB;IACxB;IACA,uBAAuB,oCAAoC,EAAE;;IAE7D,SAAS;IACT,OAAO,kBAAkB,EAAE,gBAAgB,EAAE,YAAY,MAAM,qBAAqB,EAAE;IACtF;MACE,iBAAiB,EAAE,OAAO;MAC1B;;;2DAGqD;IACvD;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,0BAA0B;MAC1B,QAAQ;MACR,mBAAmB;IACrB;;IAEA;MACE,aAAa;QACX,gBAAgB;QAChB,iBAAiB;IACrB;IACA;MACE,aAAa;IACf;;;;IAIA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,aAAa;MACb,YAAY;MACZ,mBAAmB;cACX,mBAAmB;;IAE7B;;;IAGA;MACE,cAAc;QACZ,mBAAmB;QACnB,iEAAiE;QACjE,mCAAmC;QACnC,iBAAiB;IACrB;;IAEA;cACU,gBAAgB;QACtB,cAAc;;QAEd,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,cAAc;MACd,UAAU;;MAEV,iBAAiB;MACjB,oBAAoB;IACtB;;AAEJ;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;IAEI,UAAU,YAAY,EAAE,oBAAoB,CAAC,iBAAiB,EAAE;;IAEhE;MACE,kBAAkB;QAChB,OAAO;QACP,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;QACX,gBAAgB;IACpB;IACA;;;MAGE,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,qCAAqC;MACrC,eAAe;MACf,kCAAkC;MAClC,cAAc;MACd,gBAAgB;MAChB,aAAa;MACb,0CAA0C;IAC5C;IACA;MACE,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,qCAAqC;MACrC,sBAAsB;MACtB,kCAAkC;MAClC,cAAc;MACd,gBAAgB;MAChB,aAAa;IACf;;IAEA,4BAA4B;IAC5B;mBACe,mBAAmB;QAC9B,mBAAmB;QACnB,6BAA6B;QAC7B,oBAAoB;QACpB,gBAAgB;QAChB,mBAAmB;QACnB,UAAU;QACV,oBAAoB;IACxB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;;IAEA;;MAEE,WAAW;IACb;;IAEA;MACE,aAAa;MACb,0BAA0B;MAC1B,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;IACjB;;IAEA;;MAEE,WAAW;MACX,kBAAkB;MAClB,mBAAmB;MACnB,yBAAyB;MACzB,eAAe;IACjB;;IAEA;;MAEE,aAAa;MACb,qBAAqB;MACrB,0CAA0C;IAC5C;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,oBAAoB;MACpB,YAAY;MACZ,mBAAmB;MACnB,cAAc;MACd,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,SAAS;MACT,gBAAgB;IAClB;;IAEA;MACE,OAAO;MACP,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;cACU,gBAAgB;QACtB,eAAe;QACf,cAAc;QACd,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;MACnB,yBAAyB;IAC3B;;IAEA;MACE,aAAa;MACb,0CAA0C;MAC1C,kBAAkB;MAClB,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,WAAW;IACb;;IAEA;MACE,cAAc;MACd,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,YAAY;MACZ,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,mBAAmB;MACnB,eAAe;MACf,WAAW;MACX,cAAc;MACd,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,YAAY;MACZ,mBAAmB;MACnB,cAAc;MACd,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE;QACE,gBAAgB;YACZ,2BAA2B;YAC3B,oBAAoB;MAC1B;;MAEA;QACE,mBAAmB;QACnB,qBAAqB;QACrB,uBAAuB;MACzB;;MAEA;QACE,aAAa;QACb,gBAAgB;MAClB;;MAEA;QACE,aAAa;QACb,gBAAgB;MAClB;IACF;;IAEA;MACE;QACE,aAAa;MACf;;IAEF;IACA;MACE,iBAAiB,EAAE,WAAW,EAAE,QAAQ;MACxC,2BAA2B;MAC3B,0BAA0B;MAC1B,eAAe;MACf,mBAAmB;IACrB;IACA;MACE,YAAY;MACZ,eAAe;MACf,mBAAmB;MACnB,YAAY;MACZ,wEAAwE;MACxE,YAAY;MACZ,gBAAgB;MAChB,cAAc;MACd,kDAAkD;MAClD,eAAe;MACf,mBAAmB;MACnB,eAAe;MACf,WAAW;IACb;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,wEAAwE;IAC1E;IACA;MACE,gBAAgB;MAChB,wBAAwB;MACxB,kBAAkB;MAClB,eAAe;MACf,qBAAqB;MACrB,gBAAgB;IAClB;;;IAGA,aAAa;IACb;MACE,oBAAoB;;;IAGtB;;IAEA;MACE,gBAAgB;MAChB,qCAAqC;MACrC,iBAAiB;MACjB,mBAAmB;MACnB,yBAAyB;MACzB,6BAA6B;MAC7B,cAAc;MACd,qDAAqD;MACrD,kBAAkB;IACpB;IACA,oBAAoB,2BAA2B,EAAE,2CAA2C,EAAE;IAC9F;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,cAAc;IAChB;;IAEA;MACE,aAAa;QACX,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;QACrB,YAAY;QACZ,oBAAoB;QACpB,mCAAmC;IACvC;;;IAGA,WAAW;IACX,SAAS,oBAAoB,EAAE,mBAAmB,EAAE;IACpD;MACE,YAAY,EAAE,sBAAsB,EAAE,QAAQ;MAC9C,gBAAgB;IAClB;IACA,gBAAgB,0BAA0B,EAAE,0BAA0B,EAAE;IACxE,YAAY,YAAY,EAAE;;IAE1B,SAAS;IACT;MACE,2BAA2B;MAC3B,SAAS,CAAC,UAAU;MACpB,SAAS,CAAC,WAAW;MACrB,eAAe,CAAC,kBAAkB;MAClC,kBAAkB,CAAC,QAAQ;IAC7B;;;IAGA;MACE,iBAAiB;MACjB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,4DAA4D;MAC5D,SAAS;MACT,gBAAgB;IAClB;;;IAGA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,cAAc;MACd,+BAA+B;IACjC;;IAEA;MACE,sBAAsB;IACxB;;AAEJ;;;AAGA;;;;;CAKC;;AAED;;;IAGI;MACE,mCAAmC;MACnC,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;MACnB,4CAA4C;MAC5C,kBAAkB;MAClB,gBAAgB;;IAElB;;EAEF;QACM,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;MACnB;;AAEN;EACE,YAAY,EAAE,qCAAqC,EAAE,QAAQ;AAC/D,YAAY,EAAE;;EAEZ;MACI,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;MACf,sBAAsB;MACtB,gBAAgB;IAClB;AACJ;MACM,aAAa;QACX,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;QACrB,UAAU;QACV,oBAAoB;gBACZ,mCAAmC;MAC7C;;IAEF;MACE,mCAAmC;MACnC,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,gBAAgB;MAChB,mBAAmB;;;IAGrB;IACA;MACE,SAAS;MACT,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,iBAAiB;IACnB;;EAEF;YACU,mBAAmB;QACvB,UAAU;QACV,wCAAwC;QACxC,mBAAmB;QACnB,6BAA6B;QAC7B,oBAAoB;EAC1B;EACA;IACE,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;GACC;MACG,YAAY;MACZ,oBAAoB;MACpB,YAAY;MACZ,mBAAmB;MACnB,YAAY;MACZ,wEAAwE;MACxE,YAAY;MACZ,gBAAgB;MAChB,cAAc;MACd,kDAAkD;MAClD,eAAe;MACf,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,qDAAqD;QACrD,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;MACE,YAAY;MACZ,cAAc;MACd,qBAAqB;MACrB,iBAAiB;MACjB,uBAAuB;MACvB,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,2BAA2B;MAC3B,QAAQ;MACR,0CAA0C;MAC1C;;;sEAGgE;MAChE,mBAAmB;MACnB,8CAA8C;MAC9C,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR;;4FAEsF;MACtF,WAAW;IACb;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,sBAAsB;MACtB,eAAe;MACf,YAAY;MACZ,oBAAoB;MACpB,iBAAiB;MACjB,aAAa;MACb,uDAAuD;MACvD,UAAU;MACV,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,aAAa;MACb,kBAAkB;IACpB;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;MACvB,kBAAkB;MAClB,4BAA4B;MAC5B,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,qCAAqC;MACrC,cAAc;MACd,cAAc;MACd,cAAc;MACd,gBAAgB;MAChB,yBAAyB;MACzB,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,6CAA6C;IAC/C;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,gCAAgC;MAChC,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,6CAA6C;IAC/C;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,mBAAmB;MACnB,wCAAwC;MACxC,mBAAmB;MACnB,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,UAAU;MACV,8CAA8C;IAChD;;IAEA;MACE;;;sEAGgE;IAClE;;IAEA;MACE;;;sEAGgE;QAC9D,qBAAqB;IACzB;;IAEA;MACE,cAAc;IAChB;;GAED;MACG,mBAAmB;QACjB,YAAY;QACZ,mBAAmB;QACnB,sBAAsB;QACtB,wCAAwC;QACxC,iBAAiB;QACjB,mBAAmB;QACnB,yBAAyB;QACzB,6BAA6B;QAC7B,eAAe;QACf,qDAAqD;QACrD,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,oBAAoB;IACxB;;GAED;cACW,qBAAqB;QAC3B,kBAAkB;QAClB,eAAe;QACf,sBAAsB;QACtB,gBAAgB;IACpB;;;IAGA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;MACf,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,oBAAoB;IACtB;;;KAGC;MACC,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;MACf,sBAAsB;MACtB,gBAAgB;MAChB,UAAU;IACZ;;IAEA;aACS,mBAAmB;QACxB,uBAAuB;QACvB,yBAAyB;QACzB,eAAe;QACf,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;IACA;MACE,mBAAmB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;IAChB;;EAEF;MACI,aAAa;MACb,oDAAoD;MACpD,UAAU;MACV,aAAa;MACb,eAAe;MACf,mBAAmB;EACvB;;EAEA;IACE,mBAAmB;QACf,kBAAkB;QAClB,2BAA2B;QAC3B,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;EACtB;EACA;IACE,mCAAmC;QAC/B;;qBAEa;QACb,aAAa;;EAEnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,eAAe,qCAAqC,EAAE;;;EAGtD;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,mDAAmD;IACnD,gBAAgB;IAChB,oBAAoB;;EAEtB;;;;IAIE,6CAA6C;IAC7C;MACE,YAAY;MACZ,iBAAiB;IACnB;;IAEA;IACA,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,wCAAwC;IACxC,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB;;;;EAIF;IACE;;;;mBAIe;EACjB;EACA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;;EAGA,gCAAgC;EAChC;YACU,mBAAmB;QACvB,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;QAChB,oBAAoB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;IAC9C,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,0EAA0E;IAC1E,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2CAA2C;IAC3C,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,wEAAwE;IACxE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;IAC9C,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,8DAA8D;EAChE;;EAEA;IACE,yBAAyB;IACzB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE;MACE,oBAAoB;IACtB;;IAEA;MACE,eAAe;MACf,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;MACvB,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;;IAEA;;MAEE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;;IAGE,4BAA4B;IAC5B;MACE,aAAa;MACb,8BAA8B;MAC9B,UAAU;MACV,iBAAiB;IACnB;;;;IAIA,gBAAgB;IAChB;MACE,gBAAgB;QACd,UAAU;QACV,WAAW;IACf;;IAEA;MACE;QACE,kCAAkC;QAClC,aAAa;QACb,mEAAmE;QACnE,kBAAkB;QAClB,6BAA6B;QAC7B,wBAAwB;QACxB,cAAc;MAChB;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,WAAW;QACX,eAAe;QACf,gDAAgD;QAChD,SAAS;MACX;;MAEA;QACE,WAAW;MACb;;MAEA;QACE,WAAW;QACX,wCAAwC;QACxC,qBAAqB;QACrB,iBAAiB;QACjB,MAAM;MACR;;MAEA;;;;QAIE,WAAW;QACX,eAAe;QACf,cAAc;QACd,eAAe;QACf,qBAAqB;QACrB,sBAAsB;MACxB;;MAEA;QACE,gBAAgB;MAClB;;MAEA;QACE,eAAe;MACjB;;MAEA;;QAEE,cAAc;QACd,WAAW;QACX,eAAe;QACf,YAAY;MACd;;MAEA;;QAEE,WAAW;MACb;;MAEA;;;;QAIE,YAAY;QACZ,eAAe;QACf,sBAAsB;MACxB;;MAEA;;;QAGE,wBAAwB;MAC1B;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,WAAW;QACX,eAAe;QACf,eAAe;QACf,sBAAsB;MACxB;IACF;;;AAGJ;;;AAGA,4DAA4D;AAC5D;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;YACU,eAAe;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;QACN,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,uCAAuC;QACvC,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,2CAA2C;QAC3C,gBAAgB;QAChB,6CAA6C;EACnD;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,wEAAwE;IACxE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;;EAEjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;QACP,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;GAEC;IACC,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;AACF;;;;AAIA;;;;CAIC;;;AAGD;;EAEE;MACI,cAAc;QACZ,mBAAmB;QACnB,iEAAiE;QACjE,mCAAmC;QACnC,iBAAiB;QACjB,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;MACE,mCAAmC;MACnC,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;MACnB,4CAA4C;MAC5C,oBAAoB;;IAEtB;EACF;QACM,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;MAClB;;AAEN;MACM,oBAAoB;QAClB,sCAAsC;QACtC,aAAa;QACb,oBAAoB;;MAEtB;;QAEE;KACH,iBAAiB;QACd,mCAAmC;QACnC,gBAAgB;QAChB,kBAAkB;;IAEtB;AACJ;MACM,iBAAiB;QACf,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;QACrB,UAAU;QACV,oBAAoB;QACpB,mCAAmC;;MAErC;;;IAGF;KACC,oBAAoB;QACjB,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,yCAAyC;QACzC,mBAAmB;IACvB;;;IAGA;IACA,aAAa;IACb,oDAAoD;IACpD,OAAO;;EAET;;AAEF;IACI,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;EACd;;GAEC;IACC,gBAAgB;IAChB,cAAc;EAChB;EACA;eACa,mBAAmB;QAC1B,6BAA6B;QAC7B,qDAAqD;QACrD,wBAAwB;QACxB,oBAAoB;QACpB,gBAAgB;QAChB,YAAY;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,WAAW;IACX,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,YAAY;EACd;;GAEC;eACY,WAAW;QAClB,kBAAkB;QAClB,sBAAsB;QACtB,wCAAwC;QACxC,iBAAiB;QACjB,yBAAyB;;;QAGzB,mBAAmB;QACnB,6BAA6B;QAC7B,qDAAqD;QACrD,wBAAwB;QACxB,oBAAoB;QACpB,gBAAgB;QAChB,YAAY;;;;IAIhB;;EAEF;IACE,cAAc;QACV,mBAAmB;QACnB,gBAAgB;EACtB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,YAAY;IACZ,oBAAoB;EACtB;;GAEC;MACG,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;MACf,sBAAsB;MACtB,gBAAgB;IAClB;;;IAGA;MACE,mBAAmB;QACjB,eAAe;QACf,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,oBAAoB;QACpB,kBAAkB;IACtB;IACA;cACU,mBAAmB;QACzB,oBAAoB;QACpB,eAAe;QACf,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;IACA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;MACf,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,oBAAoB;IACtB;IACA;MACE,YAAY;MACZ,oBAAoB;MACpB,YAAY;MACZ,mBAAmB;MACnB,YAAY;MACZ,wEAAwE;MACxE,YAAY;MACZ,gBAAgB;MAChB,cAAc;MACd,kDAAkD;MAClD,eAAe;MACf,mBAAmB;MACnB,gBAAgB;IAClB;;;;EAIF,MAAM,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;EAC3D,YAAY,WAAW,EAAE;EACzB;IACE,cAAc;IACd,QAAQ;IACR,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;EACV;EACA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,sBAAsB;EACxB;EACA;YACU,kBAAkB;QACtB,wBAAwB;QACxB,mBAAmB;QACnB,eAAe;QACf,uBAAuB;QACvB,WAAW;QACX,iBAAiB;EACvB;EACA;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;YACU,WAAW;QACf,gBAAgB;QAChB,uBAAuB;QACvB,aAAa;QACb,oBAAoB;QACpB,kBAAkB;QAClB,UAAU;EAChB;EACA;IACE,WAAW;IACX,8BAA8B;IAC9B,yFAAyF;IACzF,8CAA8C;EAChD;AACF;UACU,gBAAgB;QAClB,sBAAsB;QACtB,yBAAyB;QACzB,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB,wBAAwB;QACxB,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,YAAY;AACpB;EACE,OAAO,kBAAkB,EAAE;EAC3B,YAAY,QAAQ,EAAE;;;;IAIpB;MACE,mCAAmC;MACnC,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,gBAAgB;MAChB,mBAAmB;;;IAGrB;IACA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;IACtB;;EAEF;IACE,gBAAgB;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,eAAe;QACf,qBAAqB;QACrB,eAAe;QACf,kBAAkB;EACxB;;;EAGA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;EACrB;;;;EAIA;YACU,mCAAmC;QACvC,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;QACf,kBAAkB;QAClB,kBAAkB;;EAExB;;EAEA;IACE,YAAY;QACR,mBAAmB;QACnB,qBAAqB;QACrB,kBAAkB;QAClB,UAAU;QACV,oBAAoB;EAC1B;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;EACA,SAAS,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,qBAAqB;;;EAG7E;YACU,gBAAgB;QACpB,UAAU;QACV,oBAAoB;EAC1B;;;;AAIF;;;AAGA;IACI;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;AACJ;;;AAGA;IACI;QACI,eAAe;IACnB;AACJ;;;CAGC;MACK;QACE,aAAa;MACf;;MAEA;UACI,gBAAgB;UAChB,eAAe;UACf,cAAc;UACd,UAAU;UACV,oBAAoB;UACpB,kBAAkB;MACtB;IACF;;AAEJ;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;;uDAGqD;AACvD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;;;;;;;EAOE,mFAAmF;EACnF,cAAc;EACd,+CAA+C;AACjD;;AAEA;;;;;;;EAOE,qEAAqE;AACvE;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;;;;;;;EASE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,aAAa;IACb,WAAW;IACX,eAAe;IACf,gDAAgD;IAChD,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB;;oEAEgE;IAChE,8CAA8C;IAC9C,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX;;0FAEsF;EACxF;;EAEA;IACE;;oEAEgE;EAClE;;EAEA;IACE;;oEAEgE;EAClE;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;EAChD;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[":root{\n  --bgTop: #04b0fab4;\n  --bgMid: rgb(0 108 203 / 93%);\n  --ink: #0D1B2A;\n  --shadow: 0 8px 14px rgba(13, 27, 42, 0.18);\n  --shadowSoft: 0 10px 28px rgba(13, 27, 42, 0.12);\n  --radiusLg: 20px;\n  --container: 633px;\n  --accentBlue: #004b7aa4;\n}\n\nhtml[data-brand=\"house-helper\"] {\n  --bgTop: #7cc243;\n  --bgMid: #2f7d32;\n  --ink: #102318;\n  --shadow: 0 8px 14px rgba(24, 83, 33, 0.18);\n  --shadowSoft: 0 10px 28px rgba(24, 83, 33, 0.12);\n  --accentBlue: #2f7d32;\n  --brandPrimary: #2f7d32;\n  --brandPrimaryDark: #1b5e20;\n  --brandPrimaryBright: #7cc243;\n  --brandPrimarySoft: #edf8e7;\n  --brandAccent: #f4c430;\n}\n\n\n*{ box-sizing: border-box; }\nhtml, body{ height:100%; }\nbody{ margin:0; font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial; color: var(--ink); }\na{ color: inherit; text-decoration: none; }\nbutton, select{ font: inherit; }\n\n.page{ min-height:100vh; background: #fcfaf6; }\n.container{ width: 760px; \n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n/* ==========================\n   SERVICE PROVIDER PROFILE\n   ========================== */\n\n.provider-hero {\n  background: linear-gradient(135deg, #1d4ed8, #0ea5e9);\n  color: #ffffff;\n  padding: 32px 16px;\n}\n\n.provider-hero-inner {\n  max-width: 730px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.provider-logo-wrap {\n  width: 80px;\n  height: 80px;\n  border-radius: 16px;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);\n}\n\n.provider-logo-img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.provider-logo-placeholder {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.provider-hero-copy {\n  flex: 1;\n}\n\n.provider-hero-gallery {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.provider-hero-gallery-button {\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  border: none;\n  background: rgba(15, 23, 42, 0.25);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.provider-hero-gallery-button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.provider-hero-gallery-strip {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding: 4px 2px;\n}\n\n.provider-hero-thumb-wrap {\n  flex: 0 0 auto;\n}\n\n.provider-hero-thumb {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  object-fit: cover;\n  border: 2px solid rgba(255, 255, 255, 0.7);\n  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.25);\n  cursor: pointer;\n}\n\n.provider-hero-title {\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 6px;\n}\n\n.provider-hero-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.provider-hero-tags span {\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e3a8a;\n}\n\n.provider-hero-serving {\n  font-size: 13px;\n  opacity: 0.9;\n}\n\n.provider-main {\n  max-width: 730px;\n  margin: 0 auto;\n  padding: 32px 16px 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.provider-main-left {\n  flex: 3;\n}\n\n.provider-photo-card {\n  background: #ffffff;\n  border-radius: 18px;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n  padding: 18px 20px 16px;\n  margin-bottom: 18px;\n}\n\n.provider-photo-title {\n  margin: 0 0 10px;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.provider-photo-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.provider-photo-thumb-wrap {\n  border: none;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.provider-photo-thumb {\n  width: 80px;\n  height: 80px;\n  border-radius: 10px;\n  object-fit: cover;\n  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.2);\n}\n\n.provider-photo-empty {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.provider-main-right {\n  flex: 1;\n}\n\n.provider-table-card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.provider-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.provider-table th {\n  background: #f9fafb;\n  text-align: left;\n  padding: 10px 14px;\n  font-weight: 600;\n  border-bottom: 1px solid #e5e7eb;\n  width: 170px;\n}\n\n.provider-table td {\n  padding: 10px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.provider-gallery-card {\n  margin-top: 20px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);\n  padding: 20px;\n}\n\n.provider-gallery-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 12px;\n}\n\n.provider-gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.provider-gallery-img {\n  width: 100%;\n  height: 150px;\n  border-radius: 12px;\n  object-fit: cover;\n}\n\n.provider-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.provider-modal-content {\n  position: relative;\n  max-width: 900px;\n  width: 90%;\n  max-height: 90vh;\n  background: #020617;\n  border-radius: 16px;\n  padding: 16px 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.provider-modal-image {\n  max-width: 100%;\n  max-height: 80vh;\n  border-radius: 12px;\n  object-fit: contain;\n}\n\n.provider-modal-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  border: none;\n  background: rgba(15, 23, 42, 0.85);\n  color: #f9fafb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.provider-modal-arrow--left {\n  left: 10px;\n}\n\n.provider-modal-arrow--right {\n  right: 10px;\n}\n\n.provider-modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  border: none;\n  background: rgba(15, 23, 42, 0.9);\n  color: #f9fafb;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n/* Mobile tweaks for provider profile */\n@media (max-width: 550px) {\n  .provider-hero {\n    padding: 16px 12px;\n  }\n  \n\n  .provider-hero-inner {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .provider-logo-wrap {\n    width: 68px;\n    height: 68px;\n  }\n\n  .provider-hero-title {\n    font-size: 20px;\n  }\n\n  .provider-hero-gallery {\n    margin-top: 8px;\n  }\n\n  .provider-hero-gallery-strip {\n    max-width: 100%;\n  }\n\n  .provider-hero-thumb {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.provider-cta-card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);\n  padding: 20px 18px;\n}\n\n.provider-cta-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 10px;\n}\n\n.provider-cta-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.provider-cta-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.provider-cta-input {\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  padding: 8px 10px;\n  font-size: 14px;\n}\n\n.provider-cta-button {\n  margin-top: 4px;\n  width: 100%;\n  border-radius: 999px;\n  border: none;\n  padding: 10px 14px;\n  background: #16a34a;\n  color: #ffffff;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.provider-cta-button:hover {\n  background: #15803d;\n}\n\n.provider-cta-note {\n  margin-top: 8px;\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.provider-request-button {\n  margin-top: 4px;\n}\n\n@media (min-width: 900px) {\n  .provider-main {\n    flex-direction: row;\n  }\n}\n\n\n/* DEFAULT STYLES ALL SIZES */\n@media (max-width: 10568px){\n\n    /* Header */\n    .header{\n      position: sticky; top: 0; z-index: 20;\n      background: rgba(255,255,255,0.10);\n      backdrop-filter: blur(10px);\n      border-bottom: 1px solid rgba(134, 134, 134, 0.187);\n    }\n    .headerInner{\n      display:flex; align-items:center; justify-content:space-between;\n      padding: 16px 0;\n    }\n\n    \n    .logo{ display:flex; align-items:center; gap: 6px;  color: #0B2A6B; min-width: 0; }\n    .homeLink{\n      display: inline-flex;\n      align-items: center;\n      min-width: 0;\n      flex: 1 1 auto;\n    }\n    .logoMark{\n        width: 50px;\n        height: 50px;\n        border-radius: 14px;\n        background: rgba(255, 255, 255, 0.75);\n        display: grid;\n        place-items: center;\n        box-shadow: var(--shadowSoft);\n        color: #FF7A00;\n        margin-left: -5px;\n        border: solid 1px rgba(0, 0, 0, 0.122);\n        \n    }\n    .logoMark svg{ width: 38px; height: 38px;    margin-top: -5px; }\n    .logoText{ line-height: 1.0;padding-right: 15px; min-width: 0; }\n    .brand{ font-weight: 900; font-size: 32px; letter-spacing: -0.6px; color: #016faf; }\n    .dot{ font-weight: 900; color: #FF7A00; margin-left: -8px; }\n    .tagline{ \n              font-size: 11px;\n        letter-spacing: 0.6px;\n        font-weight: 800;\n        opacity: 0.75;\n        margin-top: 4px;\n     }\n\n    .contractorLink{\n      font-weight: 700; color: rgba(255,255,255,0.92);\n      padding: 10px 14px; border-radius: 999px;\n      border: 1px solid rgba(255,255,255,0.22);\n      background: rgba(13,27,42,0.10);\n      color:rgb(0, 166, 255);\n    }\n    .contractorLink:hover{ background: rgba(255, 193, 9, 0.426); }\n\n    /* Hero */\n    .hero{ position: relative; overflow: hidden; color: white;     padding: 12px 0px 3px; }\n    .heroBg{\n      position:absolute; inset:0;\n      background:\n        radial-gradient(1200px 600px at 20% 40%, rgba(255,255,255,0.18), transparent 60%),\n        radial-gradient(900px 500px at 85% 30%, rgba(20,200,182,0.20), transparent 55%),\n        linear-gradient(160deg, var(--bgTop), var(--bgMid));\n    }\n\n    .heroInner{\n      position: relative;\n      display: grid;\n      grid-template-columns: 1fr;\n      gap: 2px;\n      align-items: center;\n    }\n\n    .heroTop{ \n      display: grid;\n        text-align: left;\n        align-self: start;\n    }\n    .heroLatestReportBadgeWrap {\n      display: none;\n    }\n\n\n\n    .regtrade {\n      font-size: 0.25em;\n      vertical-align:top;\n      color:#016faf;\n      filter: none;\n      font-weight: normal;\n              margin-right: -10px;\n      \n    }\n\n\n    .brandEm{ \n      color: #005d97;\n        white-space: nowrap;\n        /* filter: drop-shadow(1px 1px 1px rgba(255, 255, 255, 0.562)); */\n        font-size: clamp(40px, 2.4vw, 34px);\n        margin-top: -10px;\n    }\n\n    .brand_small {\n              font-size: 0.5em;\n        color: #005d97;\n        \n        font-weight: 700;\n        letter-spacing: -0.6px;\n        margin-left: 3px;\n    }\n\n    .personaImg{\n      width: min(90%);\n      height: auto;\n      display: block;\n      padding: 0;\n      \n      user-select: none;\n      pointer-events: none;\n    }\n\n.faqPage {\n  padding: 0 10px;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.faqPage__title {\n  font-size: 30px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.faqPage__subtitle {\n  text-align: center;\n  margin-bottom: 10px;\n  color: #666;\n}\n\n.faqPage__section {\n  margin-bottom: 10px;\n  width: 546px;\n  justify-self: center;\n}\n\n.faqPage__sectionTitle {\n  font-size: 24px;\n  margin-bottom: 10px;\n  margin-top: 30px;\n}\n\n.faqPage__card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  padding: 0 10px;\n  background: #fff;\n}\n\n.faqPage__questionRow {\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.faqPage__question {\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.faqPage__answer {\n  margin-top: 10px;\n  color: #444;\n  line-height: 1.6;\n}\n\n.faqPage__icon {\n  font-size: 20px;\n  margin-top: 0;\n}\n\n.faqPage__cta {\n  margin-top: 30px;\n  padding: 20px;\n  text-align: center;\n  background: #f3f4f6;\n  border-radius: 12px;\n  max-width: 400px;\n  justify-self: center;\n}\n\n.faqPage__ctaTitle {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: -4px;\n  margin-top: -2px;\n}\n\n.faqPage__button {\n  margin-top: 10px;\n  padding: 12px 24px;\n  border-radius: 8px;\n  border: none;\n  background: #4f46e5;\n  color: #fff;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n    .formRow{ display:flex; align-items: stretch;padding-left: 5px; }\n\n    .selectWrap{ \n      position: relative;\n        flex: 1;\n        width: 200px;\n        margin-left: 4px;\n        margin-right: 8px;\n        width: 100%;\n        max-width: 250px;\n    }\n    .heroForm input[type=\"text\"],\n    .heroForm input[name=\"zip\"],\n    .heroForm input#homepage-zip {\n      width: 100%;\n      height: 52px;\n      border-radius: 14px;\n      border: 1px solid rgba(13,27,42,0.10);\n      padding: 0 16px;\n      background: rgba(255,255,255,0.98);\n      color: #132238;\n      font-weight: 700;\n      outline: none;\n      box-shadow: 0 6px 16px rgba(15,23,42,0.16);\n    }\n    .heroForm input::placeholder {\n      color: #9ca3af;\n      font-weight: 500;\n    }\n    select{\n      width: 100%;\n      height: 52px;\n      border-radius: 14px;\n      border: 1px solid rgba(13,27,42,0.10);\n      padding: 0 44px 0 16px;\n      background: rgba(255,255,255,0.95);\n      color: #132238;\n      font-weight: 700;\n      outline: none;\n    }\n\n    /* Financing widget layout */\n    .financing-widget-card{\n                   background: #ffffff;\n        border-radius: 20px;\n        box-shadow: var(--shadowSoft);\n        padding: 1px 7px 6px;\n        margin: 5px 15px;\n        margin-bottom: 25px;\n        width: 75%;\n        justify-self: center;\n    }\n\n    .financing-widget-title{\n      font-size: 24px;\n      margin: 6px 0 4px;\n    }\n\n    .financing-widget-subtitle{\n      margin: 0 0 16px;\n      color: #4b5563;\n      font-size: 14px;\n    }\n\n    .financing-widget-layout{\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n    }\n\n    .financing-widget-left,\n    .financing-widget-right{\n      width: 100%;\n    }\n\n    .financing-widget-grid{\n      display: grid;\n      grid-template-columns: 1fr;\n      gap: 12px;\n      margin-bottom: 16px;\n    }\n\n    .financing-widget-field label{\n      display: block;\n      font-weight: 600;\n      margin-bottom: 4px;\n      font-size: 13px;\n    }\n\n    .financing-widget-field input,\n    .financing-widget-field select{\n      width: 100%;\n      padding: 10px 12px;\n      border-radius: 10px;\n      border: 1px solid #d1d5db;\n      font-size: 14px;\n    }\n\n    .financing-widget-field input:focus,\n    .financing-widget-field select:focus{\n      outline: none;\n      border-color: #2563eb;\n      box-shadow: 0 0 0 1px rgba(37,99,235,0.25);\n    }\n\n    .financing-widget-calc{\n      margin-top: 8px;\n      padding: 10px 16px;\n      border-radius: 999px;\n      border: none;\n      background: #016faf;\n      color: #ffffff;\n      font-weight: 700;\n      cursor: pointer;\n    }\n\n    .financing-widget-calc:disabled{\n      opacity: 0.6;\n      cursor: default;\n    }\n\n    .financing-widget-actions--left{\n      margin-top: 14px;\n    }\n\n    .financing-widget-results{\n      display: flex;\n      gap: 16px;\n      margin-top: 16px;\n    }\n\n    .financing-widget-amount{\n      flex: 1;\n      text-align: left;\n    }\n\n    .financing-widget-amount .label{\n      font-size: 12px;\n      color: #6b7280;\n      margin-bottom: 2px;\n    }\n\n    .financing-widget-amount .value{\n      font-size: 18px;\n      font-weight: 700;\n    }\n\n    .financing-widget-error{\n      color: #dc2626;\n      font-size: 13px;\n      font-weight: 600;\n      margin-bottom: 10px;\n    }\n\n    .financing-widget-disclaimer{\n              margin-top: 16px;\n        font-size: 11px;\n        color: #6b7280;\n        justify-self: center;\n        text-align: center;\n    }\n\n    .financing-widget-ai{\n      padding: 12px 14px;\n      border-radius: 16px;\n      background: #f9fafb;\n      border: 1px solid #e5e7eb;\n    }\n\n    .financing-widget-ai-header{\n      display: grid;\n      grid-template-columns: auto minmax(0, 1fr);\n      align-items: start;\n      gap: 14px;\n      margin-bottom: 8px;\n    }\n\n    .financing-widget-ai-badge{\n      grid-column: 1;\n      grid-row: 1;\n    }\n\n    .financing-widget-ai-heading{\n      grid-column: 2;\n      grid-row: 1;\n      min-width: 0;\n      align-self: center;\n    }\n\n    .financing-widget-ai-badge .hh-badge-image{\n      max-width: 120px;\n      height: auto;\n      display: block;\n    }\n\n    .financing-widget-ai-heading h3{\n      margin: 0 0 4px;\n    }\n\n    .financing-widget-ai h3{\n      margin: 13px 0 8px;\n      font-size: 21px;\n    }\n\n    .financing-widget-ai-placeholder{\n      grid-column: 1 / -1;\n      margin: 2px 0 0;\n      width: 100%;\n      color: #374151;\n      font-size: 14px;\n      line-height: 1.5;\n    }\n\n    .financing-widget-ai-box{\n      min-height: 8px;\n      font-size: 14px;\n      color: #374151;\n    }\n\n    .financing-widget-cta{\n      margin-top: 16px;\n      padding: 10px 16px;\n      border-radius: 999px;\n      border: none;\n      background: #10b981;\n      color: #ffffff;\n      font-weight: 700;\n      cursor: pointer;\n    }\n\n    @media (min-width: 551px){\n      .financing-widget-card{\n        max-width: 620px;\n            padding: 7px 15px 10px 19px;\n            justify-self: center;\n      }\n\n      .financing-widget-layout{\n        flex-direction: row;\n        justify-content: left;\n        align-items: flex-start;\n      }\n\n      .financing-widget-left{\n        flex: 0 0 30%;\n        max-width: 360px;\n      }\n\n      .financing-widget-right{\n        flex: 0 0 66%;\n        max-width: 720px;\n      }\n    }\n\n    @media (max-width: 550px){\n      .financing-widget-left-submitted{\n        display: none;\n      }\n\n    }\n    .selectChevron{\n      position:absolute; right: 14px; top: 50%;\n      transform: translateY(-50%);\n      color: rgba(19,34,56,0.55);\n      font-size: 18px;\n      pointer-events:none;\n    }\n    .ctaBtn{\n      height: 52px;\n      padding: 0 18px;\n      border-radius: 14px;\n      border: none;\n      background: linear-gradient(180deg, #016faf 100%, #bebec4,100%, #a7abc0);\n      color: white;\n      font-weight: 900;\n      z-index: 10000;\n      /*box-shadow: 0 14px 30px rgba(34, 0, 255, 0.35);*/\n      cursor: pointer;\n      white-space: nowrap;\n      min-width: 70px;\n      width:140px;\n    }\n    .ctaBtn:disabled{ \n      opacity: 0.55; \n      cursor: not-allowed; \n      box-shadow: none; \n      background: linear-gradient(180deg, #016faf 100%, #016faf,100%, #0026ff);\n    }\n    .heroFinePrint{ \n      font-weight: 500; \n      color: rgba(255,255,255);\n      padding-left: 12px; \n      font-size: 13px;\n      letter-spacing: .02em;\n      margin-top: 10px;\n    }\n\n\n    /* Projects */\n    .projects{ \n      justify-self: center;\n      \n      \n    }\n  \n    .projectCard{\n      appearance: none;\n      border: 1px solid rgba(13,27,42,0.10);\n      background: white;\n      border-radius: 22px;\n      padding: 0px 0px 23px 0px;\n      box-shadow: var(--shadowSoft);\n      cursor:pointer;\n      transition: transform .12s ease, box-shadow .12s ease;\n      text-align: center;\n    }\n    .projectCard:hover{ transform: translateY(-2px); box-shadow: 0 18px 38px rgba(13,27,42,0.14); }\n    .projectIcon{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 0 auto -7px\n    }\n\n    .projectIcon img{\n      width: 92px;\n      height: 92px;\n      object-fit: cover;\n      display: block;\n    }\n\n    .projectTitle{\n      margin-top: 0;\n        font-weight: 900;\n        color: #0075cfd9;\n        line-height: 1.15;\n        white-space: pre-line;\n        width: 190px;\n        justify-self: center;\n        font-size: clamp(12px, 2.5vw, 20px);\n    }\n\n\n    /* Footer */\n    .footer{ padding: 22px 0 34px; background: #F6F8FC; }\n    .footerInner{\n      display:flex; justify-content:center; gap: 1px;\n      font-weight: 700;\n    }\n    .footerInner a{ text-decoration: underline; text-underline-offset: 3px; }\n    .footerDot{ opacity: 0.6; }\n\n    /* A11y */\n    .srOnly{\n      position:absolute!important;\n      width:1px;height:1px;\n      padding:0;margin:-1px;\n      overflow:hidden;clip:rect(0,0,0,0);\n      white-space:nowrap;border:0;\n    }\n\n\n    .room-idea-results {\n      max-width: 1200px;\n      margin: 0 auto;\n    }\n\n    .image-collage {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n      gap: 16px;\n      margin-top: 24px;\n    }\n\n\n    .collage-item {\n      border-radius: 12px;\n      overflow: hidden;\n      background: #f5f5f5;\n    }\n\n    .collage-item img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      display: block;\n      transition: transform 0.3s ease;\n    }\n\n    .collage-item:hover img {\n      transform: scale(1.05);\n    }\n\n}\n\n\n/*\n******************************\n  Desktop Desktop Desktop   \n******************************\n/*  981px and up \n*/\n\n@media (min-width: 551px){\n\n\n    .heroTitle{\n      font-size: clamp(32px, 2.2vw, 46px);\n      line-height: 1.05;\n      font-weight: 700;\n      letter-spacing: 2px;\n      text-shadow: 0 10px 28px rgba(13,27,42,0.22);\n      padding-left: 15px;\n      margin-top: 30px;\n      \n    }\n\n  .logoImage {\n        width: 44px;\n        height: auto;\n        aspect-ratio: auto;\n        max-width: 44px;\n        flex: 0 0 auto;\n        border-radius: 10px;\n        display: block;\n        object-fit: contain;\n        margin-left: 3px;\n        margin-right: 3px;\n      }\n\n.projectsGrid{ \n  display:grid; grid-template-columns: repeat(5, 1fr); gap: 5px;\nwidth: 477px; }\n    \n  .projectsTitle{\n      margin: 26px 0 12px;\n      text-align: center;\n      font-size: 22px;\n      letter-spacing: -0.8px;\n      font-weight: 700;\n    }\n.projectCardTitle{\n      margin-top: 0;\n        font-weight: 900;\n        color: #0075cfd9;\n        line-height: 1.15;\n        white-space: pre-line;\n        width: 80%;\n        justify-self: center;\n                font-size: clamp(10px, 3.1vw, 16px);\n      }\n\n    .heroQuestion{\n      font-size: clamp(16px, 1.0vw, 46px);\n      line-height: 1.05;\n      font-weight: 700;\n      letter-spacing: 0.03em;\n      margin-left:10px;\n      padding-bottom:10px;\n      \n      \n    }\n    .heroByline{\n      margin: 0;\n      padding-bottom: 4px;\n      padding-top: 5px;\n      font-size: 21px;\n      line-height: 1.15;\n      font-weight: 500;\n      letter-spacing: -0.1px;\n      margin-left: 15px;\n    }\n\n  .homepageCalculatorWrap {\n            margin-bottom: 69px;\n        width: 89%;\n        border: 1px solid rgba(13, 27, 42, 0.10);\n        border-radius: 22px;\n        box-shadow: var(--shadowSoft);\n        justify-self: center;\n  }\n  .homepageLatestReportBadgeWrap {\n    width: 255px;\n    max-width: 91%;\n    margin: 4px auto 14px;\n    display: flex;\n    justify-content: center;\n  }\n  .homepageLatestReportBadgeWrap--sectionTop {\n    width: 100%;\n    max-width: 477px;\n    margin: 8px auto 10px;\n    justify-content: flex-end;\n  }\n  .homepageLatestReportBadgeWrap .latestReportBadge {\n    width: 100%;\n    justify-content: space-between;\n  }\n  .homepageLatestReportBadgeWrap--sectionTop .latestReportBadge {\n    width: auto;\n    min-width: 220px;\n    max-width: 100%;\n  }\n   .browseProvidersBtn {\n      width: 180px;\n      justify-self: center;\n      height: 52px;\n      border-radius: 14px;\n      border: none;\n      background: linear-gradient(180deg, #016faf 100%, #bebec4,100%, #a7abc0);\n      color: white;\n      font-weight: 900;\n      z-index: 10000;\n      /*box-shadow: 0 14px 30px rgba(34, 0, 255, 0.35);*/\n      cursor: pointer;\n      white-space: nowrap;\n      min-width: 205px;\n    }\n    \n    .propertyReportCTA  { \n        width: 255px;\n        cursor: pointer;\n        transition: transform .12s ease, box-shadow .12s ease;\n        text-align: center;\n        max-width: 91%;\n        margin-top: 25px;\n        justify-self: center;\n    }\n\n    .crossSiteProjectSelector {\n      width: 255px;\n      max-width: 91%;\n      margin: 25px auto 8px;\n      min-height: 316px;\n      padding: 16px 14px 18px;\n      position: relative;\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-start;\n      gap: 9px;\n      border: 1px solid rgba(226, 232, 240, 0.9);\n      background:\n        radial-gradient(130px 90px at 80% 10%, rgba(255, 255, 255, 0.78), transparent 70%),\n        radial-gradient(160px 110px at 18% 22%, rgba(255, 255, 255, 0.62), transparent 72%),\n        linear-gradient(160deg, #dff3ff 0%, #7fc8f1 48%, #016faf 100%);\n      border-radius: 24px;\n      box-shadow: 0 18px 34px rgba(13, 27, 42, 0.16);\n      text-align: left;\n      isolation: isolate;\n      cursor: pointer;\n    }\n\n    .crossSiteProjectSelector::before {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(13, 27, 42, 0.22)),\n        radial-gradient(220px 100px at 50% 110%, rgba(255, 255, 255, 0.44), transparent 72%);\n      z-index: -1;\n    }\n\n    .crossSiteProjectSelectorMascot {\n      position: relative;\n      right: auto;\n      top: auto;\n      width: min(128px, 76%);\n      max-width: none;\n      height: auto;\n      pointer-events: none;\n      user-select: none;\n      opacity: 0.94;\n      filter: drop-shadow(0 12px 18px rgba(13, 27, 42, 0.22));\n      z-index: 1;\n      margin: -2px auto -1px;\n    }\n\n    .crossSiteProjectSelectorContent {\n      position: relative;\n      z-index: 1;\n      width: 100%;\n      margin-top: 0;\n      text-align: center;\n    }\n\n    .crossSiteProjectSelectorEyebrow {\n      display: inline-flex;\n      align-items: center;\n      min-height: 24px;\n      justify-content: center;\n      width: fit-content;\n      max-width: calc(100% - 20px);\n      padding: 5px 9px;\n      margin: 0 auto 9px;\n      border-radius: 999px;\n      background: rgba(255, 255, 255, 0.76);\n      color: #005d97;\n      font-size: 9px;\n      line-height: 1;\n      font-weight: 900;\n      text-transform: uppercase;\n      letter-spacing: 0.08em;\n      white-space: nowrap;\n    }\n\n    .crossSiteProjectSelectorLabel {\n      display: block;\n      margin: 0 auto 8px;\n      max-width: 168px;\n      font-size: 21px;\n      line-height: 0.98;\n      font-weight: 900;\n      color: #ffffff;\n      text-shadow: 0 2px 8px rgba(13, 27, 42, 0.28);\n    }\n\n    .crossSiteProjectSelectorCopy {\n      margin: 0 auto 13px;\n      max-width: 152px;\n      color: rgba(255, 255, 255, 0.94);\n      font-size: 11px;\n      line-height: 1.22;\n      font-weight: 750;\n      text-shadow: 0 1px 7px rgba(13, 27, 42, 0.28);\n    }\n\n    .crossSiteProjectSelectorSelect {\n      width: 100%;\n      min-height: 46px;\n      border-radius: 14px;\n      border: 1px solid rgba(13, 27, 42, 0.24);\n      background: #ffffff;\n      color: var(--ink);\n      font-weight: 800;\n      padding: 0 12px;\n      cursor: pointer;\n      position: relative;\n      z-index: 1;\n      box-shadow: 0 10px 22px rgba(13, 27, 42, 0.16);\n    }\n\n    .crossSiteProjectSelector--home-helper {\n      background:\n        radial-gradient(140px 96px at 78% 8%, rgba(255, 255, 255, 0.82), transparent 70%),\n        radial-gradient(150px 108px at 12% 18%, rgba(255, 255, 255, 0.58), transparent 72%),\n        linear-gradient(158deg, #dff3ff 0%, #58bde8 46%, #016faf 100%);\n    }\n\n    .crossSiteProjectSelector--house-helper {\n      background:\n        radial-gradient(150px 98px at 76% 8%, rgba(255, 255, 255, 0.78), transparent 70%),\n        radial-gradient(140px 104px at 12% 18%, rgba(244, 196, 48, 0.38), transparent 72%),\n        linear-gradient(158deg, #c8efad 0%, #7cc243 42%, #2f7d32 100%);\n        border-color: #bebfc1;\n    }\n\n    .crossSiteProjectSelector--house-helper .crossSiteProjectSelectorEyebrow {\n      color: #1b5e20;\n    }\n    \n   .browseProvidersCTA   {\n      margin-bottom: 15px;\n        width: 255px;\n        /* display: grid; */\n        /* appearance: none; */\n        border: 1px solid rgba(13, 27, 42, 0.10);\n        background: white;\n        border-radius: 22px;\n        padding: 0px 0px 23px 0px;\n        box-shadow: var(--shadowSoft);\n        cursor: pointer;\n        transition: transform .12s ease, box-shadow .12s ease;\n        text-align: center;\n        max-width: 91%;\n        margin-top: 5px;\n        justify-self: center;\n    }\n\n   .browseProvidersHeader{\n              margin: 12px 1px 12px;\n        text-align: center;\n        font-size: 17px;\n        letter-spacing: -0.6px;\n        font-weight: 700;\n    }\n\n   \n    .browseProvidersbyline {\n      margin: 0 0 12px;\n      text-align: center;\n      font-size: 15px;\n      letter-spacing: -0.6px;\n      font-weight: 300;\n      width: 254px;\n      justify-self: center;\n    }\n    \n\n     .browseProvidersbyline{\n      margin: 0 0 12px;\n      text-align: center;\n      font-size: 15px;\n      letter-spacing: -0.6px;\n      font-weight: 300;\n      width: 90%;\n    }\n    \n    .browseProvidersInput{\n             margin-bottom: 12px;\n        /* margin-left: 25px; */\n        /* align-items: center; */\n        font-size: 18px;\n        letter-spacing: -0.6px;\n        font-weight: 300;\n        width: 173px;\n        height: 44px;\n        text-align: center;\n    }\n    .browseProvidersSelect{\n      margin-bottom: 12px;\n        letter-spacing: -0.6px;\n        font-weight: 600;\n        width: 180px;\n    } \n    \n  .toolgrid-template {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(220px, 1fr));\n      gap: -15px;\n      padding: 69px;\n      padding-top:0px;\n      padding-bottom: 0px;\n  }\n\n  .toolsGrid-bubble {\n    border-radius: 12px;\n        padding: 16px 12px;\n        border: 1px solid #3690ffa2;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin: 42px;\n        margin-top: 15px;\n  }\n  .heroInner{\n    grid-template-columns: 0.5fr 1.45fr; \n        grid-template-areas:\n        \"left top\"\n        \"left bottom\";\n        row-gap: 24px;\n        \n  }\n\n  .heroLeft{\n    max-width: 350px;\n  }\n\n  .projectsGrid{ grid-template-columns: repeat(3, 1fr); }  \n  \n\n  .heroTop{\n    grid-area: top;\n    text-align: left;\n    align-self: start;\n  }\n\n  .heroBottom {\n    color: rgb(255, 255, 255);\n    margin-top: -14px;\n    margin-bottom: 15px;\n    font-size: 13px;\n    font-size: 16px;\n    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.2));\n    max-width: 674px;\n    justify-self: center;\n    \n  }\n\n    \n\n    /* Bigger than mobile, smaller than desktop */\n    .personaImg{\n      width: 172px;\n      margin-left: 23px;\n    }\n\n    .heroForm{\n    max-width: 451px;\n    margin-left:10px;\n    background: rgba(255,255,255,0.10);\n    border: 1px solid rgba(255,255,255,0.18);\n    border-radius: var(--radiusLg);\n    padding: 10px;\n    box-shadow: var(--shadow);\n    margin-top: 11px;\n    margin-right: 15px;\n    }\n\n \n\n  .textShadowSolid {\n    text-shadow:\n      .5px 0 0 #979696,\n      .5px 0 0 #979696,\n      .5px 1px 0 #979696,\n      0 0 0 #979696;\n  }\n  .tool-page {\n    width: 100%;\n  }\n\n  .tool-page-inner {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: 0px 2rem 1.25rem;\n  }\n\n  .tool-page-header {\n    margin-bottom: 2rem;\n  }\n\n  .tool-page-title {\n    margin: 0;\n  }\n\n  .tool-page-description {\n    max-width: 720px;\n  }\n\n\n  /* Service Providers directory */\n  .providersPage {\n            background: #f3f4f6;\n        min-height: 100vh;\n        padding: 24px 0 40px;\n        max-width: 730px;\n        justify-self: center;\n  }\n\n  .providersHeader {\n    margin-bottom: 8px;\n  }\n\n  .providersHeader-inner {\n    max-width: 1080px;\n    margin: 0 auto;\n    padding: 0 16px;\n  }\n\n  .providersTitle {\n    margin: 0 0 4px;\n    font-size: 26px;\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .providersSubtitle {\n    margin: 0 0 16px;\n    font-size: 14px;\n    color: #4b5563;\n  }\n\n  .providersSearchCard {\n    background: #ffffff;\n    border-radius: 18px;\n    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);\n    padding: 16px 16px 18px;\n    border: 1px solid rgba(15, 23, 42, 0.06);\n  }\n\n  .providersSearchGrid {\n    display: grid;\n    grid-template-columns: minmax(0, 2.1fr) minmax(0, 1fr) minmax(0, 2fr) auto;\n    gap: 16px;\n    align-items: flex-end;\n  }\n\n  .providersField {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .providersField--compact {\n    max-width: 180px;\n  }\n\n  .providersLabel {\n    font-size: 13px;\n    font-weight: 600;\n    color: #111827;\n    margin-bottom: 4px;\n  }\n\n  .providersInput,\n  .providersSelect {\n    width: 100%;\n    height: 52px;\n    border-radius: 14px;\n    border: 1px solid rgba(13, 27, 42, 0.1);\n    padding: 0 16px;\n    font-size: 14px;\n    line-height: 1.4;\n    color: #132238;\n    background-color: rgba(255, 255, 255, 0.98);\n    font-weight: 700;\n    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.16);\n  }\n\n  .providersInput::placeholder {\n    color: #9ca3af;\n    font-weight: 500;\n  }\n\n  .providersInput:focus,\n  .providersSelect:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);\n  }\n\n  .providersHelpText {\n    margin-top: 4px;\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  .providersActions {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n\n  .providersSearchButton {\n    min-width: 160px;\n    height: 52px;\n    padding: 0 18px;\n    border-radius: 14px;\n    border: none;\n    background: linear-gradient(180deg, #016faf 100%, #bebec4 100%, #a7abc0);\n    color: #ffffff;\n    font-weight: 900;\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .providersSearchButton:hover {\n    background: linear-gradient(180deg, #0284c7, #005fa3);\n  }\n\n  .providersSearchButton:focus-visible {\n    outline: 3px solid #f97316;\n    outline-offset: 2px;\n  }\n\n  .providersResults {\n    max-width: 1080px;\n    margin: 18px auto 0;\n    padding: 0 16px;\n  }\n\n  .providersStatus {\n    text-align: center;\n    color: #4b5563;\n    font-size: 14px;\n    padding: 24px 0;\n  }\n\n  .providersTableWrap {\n    background: #ffffff;\n    border-radius: 18px;\n    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n    border: 1px solid rgba(15, 23, 42, 0.06);\n    overflow-x: auto;\n  }\n\n  .providersTable {\n    width: 100%;\n    border-collapse: collapse;\n  }\n\n  .providersTable thead {\n    background: #f3f4f6;\n  }\n\n  .providersTable th,\n  .providersTable td {\n    padding: 12px 20px;\n    font-size: 14px;\n    text-align: left;\n  }\n\n  .providersTable th {\n    font-weight: 600;\n    color: #111827;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .providersTable tbody tr:nth-child(even) {\n    background: #f9fafb;\n  }\n\n  .providersTable tbody tr {\n    cursor: pointer;\n    transition: background-color 0.12s ease, box-shadow 0.12s ease;\n  }\n\n  .providersTable tbody tr:hover {\n    background-color: #e5f2ff;\n    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.12);\n  }\n\n  .providersCell-business {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .providersLogo {\n    width: 48px;\n    height: 48px;\n    border-radius: 10px;\n    object-fit: cover;\n    border: 1px solid #e5e7eb;\n    background: #ffffff;\n  }\n\n  .providersBusinessName {\n    font-weight: 600;\n    color: #111827;\n  }\n\n  .providersPhone {\n    font-size: 13px;\n    color: #4b5563;\n    margin-top: 2px;\n  }\n\n  .providersCell-description {\n    max-width: 360px;\n    color: #4b5563;\n  }\n\n  .providersCell-actions {\n    text-align: right;\n  }\n\n  .providersProfileButton {\n    padding: 8px 14px;\n    border-radius: 999px;\n    background: #2563eb;\n    color: #ffffff;\n    border: none;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  .providersProfileButton:hover {\n    background: #1d4ed8;\n  }\n\n  .providersProfileButton:focus-visible {\n    outline: 3px solid #f97316;\n    outline-offset: 2px;\n  }\n\n  .providersTableActionsHeader {\n    text-align: right;\n  }\n\n  .visuallyHidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  @media (max-width: 550px) {\n    .providersPage {\n      padding: 16px 0 28px;\n    }\n\n    .providersHeader-inner {\n      padding: 0 12px;\n      max-width: 100%;\n    }\n\n    .providersTitle {\n      font-size: 22px;\n      text-align: center;\n    }\n\n    .providersSubtitle {\n      font-size: 13px;\n      text-align: center;\n    }\n\n    .providersSearchCard {\n      padding: 14px 12px 16px;\n      margin-top: 10px;\n    }\n\n    .providersSearchGrid {\n      grid-template-columns: 1fr;\n      gap: 12px;\n    }\n\n    .providersField--compact {\n      max-width: none;\n    }\n\n    .providersField {\n      margin-bottom: 4px;\n    }\n\n    .providersActions {\n      justify-content: stretch;\n    }\n\n    .providersSearchButton {\n      width: 100%;\n      min-width: 0;\n    }\n\n    .providersResults {\n      padding: 0 12px;\n    }\n\n    .providersTable th,\n    .providersTable td {\n      padding: 10px 12px;\n      font-size: 13px;\n    }\n\n    .providersCell-description {\n      max-width: none;\n    }\n\n    .providersLogo {\n      width: 40px;\n      height: 40px;\n    } \n  }\n\n\n    /* Projects layout wrapper */\n    .projectsLayout {\n      display: grid;\n      grid-template-columns: 1fr 0fr;\n      width: 94%;\n      margin-left: 20px;\n    }\n\n\n\n    /* Sidebar CTA */\n    .projectsSidebar {\n      position: sticky;\n        top: -10px;\n        width: 104%;\n    }\n\n    @media (min-width: 960px) {\n      .projectsLayout {\n        --projects-sidebar-width: 191.25px;\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) var(--projects-sidebar-width);\n        align-items: start;\n        gap: clamp(24px, 2.5vw, 32px);\n        width: min(100%, 1060px);\n        margin: 0 auto;\n      }\n\n      .projectsMain {\n        min-width: 0;\n      }\n\n      .projectsGrid {\n        width: 100%;\n        max-width: none;\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        gap: 16px;\n      }\n\n      .projectCard {\n        width: 100%;\n      }\n\n      .projectsSidebar {\n        width: 100%;\n        max-width: var(--projects-sidebar-width);\n        justify-self: stretch;\n        align-self: start;\n        top: 0;\n      }\n\n      .projectsSidebar .crossSiteProjectSelector,\n      .projectsSidebar .propertyReportCTA,\n      .projectsSidebar .browseProvidersCTA,\n      .projectsSidebar .homepageCalculatorWrap {\n        width: 100%;\n        max-width: none;\n        margin-left: 0;\n        margin-right: 0;\n        justify-self: stretch;\n        box-sizing: border-box;\n      }\n\n      .projectsSidebar .crossSiteProjectSelector {\n        margin-top: 72px;\n      }\n\n      .projectsSidebar .propertyReportCTA {\n        margin-top: 8px;\n      }\n\n      .projectsSidebar .homeReportCta,\n      .projectsSidebar .homeReportCtaImage {\n        display: block;\n        width: 100%;\n        max-width: 100%;\n        height: auto;\n      }\n\n      .projectsSidebar .browseProvidersHeader,\n      .projectsSidebar .browseProvidersbyline {\n        width: auto;\n      }\n\n      .projectsSidebar .browseProvidersInput,\n      .projectsSidebar .crossSiteProjectSelectorSelect,\n      .projectsSidebar .browseProvidersSelect,\n      .projectsSidebar .browseProvidersBtn {\n        min-width: 0;\n        max-width: none;\n        box-sizing: border-box;\n      }\n\n      .projectsSidebar .browseProvidersInput,\n      .projectsSidebar .browseProvidersSelect,\n      .projectsSidebar .browseProvidersBtn {\n        width: calc(100% - 32px);\n      }\n\n      .projectsSidebar .homepageCalculatorWrap {\n        margin-bottom: 15px;\n      }\n\n      .projectsSidebar .homepageCalculatorWrap .calculator-card {\n        width: 100%;\n        max-width: none;\n        margin-right: 0;\n        box-sizing: border-box;\n      }\n    }\n\n\n}\n\n\n/* Service Providers directory (mobile overrides - active) */\n@media (max-width: 550px) {\n  .providersPage {\n    padding: 16px 0 28px;\n  }\n\n  .providersHeader-inner {\n    padding: 0 12px;\n    max-width: 100%;\n  }\n\n  .providersTitle {\n    font-size: 22px;\n    text-align: center;\n    margin: 0px;\n  }\n\n  .providersSubtitle {\n            font-size: 13px;\n        text-align: center;\n        max-width: 276px;\n        justify-self: center;\n  }\n\n  .providersSearchCard {\n    padding: 14px 12px 16px;\n    margin-top: 10px;\n  }\n\n  .providersSearchGrid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .providersField--compact {\n    max-width: none;\n  }\n\n  .providersField {\n    margin-bottom: 4px;\n  }\n\n  .providersInput,\n  .providersSelect {\n    width: 90%;\n        height: 43px;\n        margin: 5px 0px 5px 0px;\n        border-radius: 14px;\n        border: 1px solid rgba(13, 27, 42, 0.1);\n        padding: 9px 12px;\n        font-size: 14px;\n        line-height: 1.4;\n        color: #132238;\n        background-color: rgba(255, 255, 255, 0.98);\n        font-weight: 700;\n        box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);\n  }\n\n  .providersInput::placeholder {\n    color: #9ca3af;\n    font-weight: 500;\n  }\n\n  .providersActions {\n    justify-content: stretch;\n  }\n\n  .providersSearchButton {\n    width: 100%;\n    min-width: 0;\n    height: 52px;\n    padding: 0 18px;\n    border-radius: 14px;\n    border: none;\n    background: linear-gradient(180deg, #016faf 100%, #bebec4 100%, #a7abc0);\n    color: #ffffff;\n    font-weight: 900;\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .providersResults {\n    padding: 0 12px;\n  }\n\n  .providersTable th,\n  .providersTable td {\n    padding: 5px 5px;\n    font-size: 13px;\n    \n  }\n\n  .providersCell-description {\n    max-width: none;\n  }\n\n  .providersLogo {\n    width: 40px;\n        height: 40px;\n        text-align: center;\n        justify-self: center;\n        display: block;\n  }\n\n  .providersBusinessName {\n    font-size: 14px;\n    text-align: center;\n  }\n\n   .providersPhone {\n    font-size: 12px;\n    color: #4b5563;\n    margin-top: 2px;\n    text-align: center;\n  }\n}\n\n\n\n/* \n**************************************\n  Mobile Mobile Mobile Mobile Mobile\n**************************************\n*/\n   \n\n@media (max-width: 550px){\n\n  .brandEm{ \n      color: #005d97;\n        white-space: nowrap;\n        /* filter: drop-shadow(1px 1px 1px rgba(255, 255, 255, 0.562)); */\n        font-size: clamp(40px, 2.4vw, 34px);\n        margin-top: -10px;\n        letter-spacing: 0.001em;\n        margin-left: 10px;\n    }\n    \n    .heroTitle{\n      font-size: clamp(32px, 2.2vw, 46px);\n      line-height: 1.05;\n      font-weight: 700;\n      letter-spacing: 2px;\n      text-shadow: 0 10px 28px rgba(13,27,42,0.22);\n      justify-self: center;\n      \n    }\n  .logoImage {\n        width: 44px;\n        height: auto;\n        aspect-ratio: auto;\n        max-width: 44px;\n        flex: 0 0 auto;\n        border-radius: 10px;\n        display: block;\n        object-fit: contain;\n        margin-left: 7px;\n      }\n \n.projectsGrid{ \n      display: inline-grid;\n        grid-template-columns: repeat(2, 28fr);\n        gap: 12px 0px;\n        justify-self: center;  \n        \n      }\n    \n        .projectsTitle{\n     margin: 10 0 12px; \n        font-size: clamp(20px, 3.1vw, 16px);\n        font-weight: 700;\n        text-align: center;\n      \n    }\n.projectCardTitle{\n      margin-top: -18px;\n        font-weight: 900;\n        color: #0075cfd9;\n        line-height: 1.15;\n        white-space: pre-line;\n        width: 95%;\n        justify-self: center;\n        font-size: clamp(13px, 3.1vw, 16px);\n        \n      }\n      \n      \n    .projectsSidebar {\n     justify-self: center;\n        align-self: center;\n        width: 100%;\n        display: flow;\n        /* background-color: rgb(65, 160, 243); */\n        margin-bottom: 20px;\n    }\n\n\n    .toolgrid-template {\n    display: grid;\n    grid-template-columns: repeat(1, minmax(220px, 1fr));\n    gap: 20;\n    \n  }\n\n.toolsGrid-bubble {\n    border-radius: 12px;\n    padding: 16px 12px;\n    border: 1px solid #3690ffa2;\n    display: \"flex\";\n    flex-direction: \"column\";\n    align-items: \"center\";\n    margin: 12px;\n  }\n\n   .ctaBtn {\n    margin: 8px auto;\n    display: block;\n  }\n  .homepageCalculatorWrap {\n               border-radius: 22px;\n        box-shadow: var(--shadowSoft);\n        transition: transform .12s ease, box-shadow .12s ease;\n        /* text-align: center; */\n        justify-self: center;\n        max-width: 287px;\n        margin: 20px;\n  }\n  .homepageLatestReportBadgeWrap {\n    width: 100%;\n    max-width: 287px;\n    margin: 12px auto 0;\n    display: flex;\n    justify-content: center;\n  }\n  .homepageLatestReportBadgeWrap--sectionTop {\n    max-width: 287px;\n    margin: 10px auto 8px;\n    justify-content: center;\n    display: none;\n  }\n  .homepageLatestReportBadgeWrap .latestReportBadge {\n    width: 100%;\n    justify-content: space-between;\n  }\n  .homepageLatestReportBadgeWrap--sectionTop .latestReportBadge {\n    width: 100%;\n    min-width: 0;\n  }\n\n   .browseProvidersCTA   {\n               width: 100%;\n        text-align: center;\n        /* appearance: none; */\n        border: 1px solid rgba(13, 27, 42, 0.10);\n        background: white;\n        padding: 0px 0px 23px 0px;\n\n\n        border-radius: 22px;\n        box-shadow: var(--shadowSoft);\n        transition: transform .12s ease, box-shadow .12s ease;\n        /* text-align: center; */\n        justify-self: center;\n        max-width: 287px;\n        margin: 20px;\n\n\n\n    }\n\n  .homeReportCta {\n    display: block;\n        margin: 10px auto 0;\n        max-width: 362px;\n  }\n\n  .homeReportCtaImage {\n    display: block;\n    width: 73%;\n    height: auto;\n    justify-self: center;\n  }\n\n   .browseProvidersHeader{\n      margin: 24px 0 12px;\n      text-align: center;\n      font-size: 20px;\n      letter-spacing: -0.6px;\n      font-weight: 700;\n    }\n\n      \n    .browseProvidersInput{\n      margin-bottom: 12px;\n        font-size: 21px;\n        letter-spacing: -0.6px;\n        font-weight: 300;\n        width: 218px;\n        justify-self: center;\n        text-align: center;\n    }\n    .browseProvidersSelect{\n              margin-bottom: 12px;\n        justify-self: center;\n        font-size: 20px;\n        letter-spacing: -0.6px;\n        font-weight: 300;\n        width: 247px;\n        font-weight: 600;\n    } \n    .browseProvidersbyline {\n      margin: 0 0 12px;\n      text-align: center;\n      font-size: 15px;\n      letter-spacing: -0.6px;\n      font-weight: 300;\n      width: 254px;\n      justify-self: center;\n    }\n    .browseProvidersBtn {\n      width: 180px;\n      justify-self: center;\n      height: 52px;\n      border-radius: 14px;\n      border: none;\n      background: linear-gradient(180deg, #016faf 100%, #bebec4,100%, #a7abc0);\n      color: white;\n      font-weight: 900;\n      z-index: 10000;\n      /*box-shadow: 0 14px 30px rgba(34, 0, 255, 0.35);*/\n      cursor: pointer;\n      white-space: nowrap;\n      min-width: 205px;\n    }\n\n     \n\n  .dot{ font-weight: 900; color: #FF7A00; margin-left: -4px; }\n  .container{ width: 100%; }\n  .headerInner{\n    padding: 8px 0;\n    gap: 8px;\n    align-items: center;\n  }\n  .homeLink{\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n  .logo{\n    width: 100%;\n    min-width: 0;\n    gap: 4px;\n  }\n  .logoImage{\n    width: 38px;\n    max-width: 38px;\n    height: auto;\n    margin-left: 4px;\n    margin-right: 2px;\n  }\n  .logoText{\n    padding-right: 0;\n  }\n  .brand{\n    font-size: 26px;\n    line-height: 0.95;\n    white-space: nowrap;\n  }\n  .tagline{\n    font-size: 9px;\n    letter-spacing: 0.04em;\n  }\n  .contractorLink{ \n            text-align: center;\n        padding: 2px 2px 2px 2px;\n        justify-self: right;\n        font-size: 11px;\n        color: rgb(0, 166, 255);\n        width: 79px;\n        margin-right: 7px;\n  }\n  .heroForm {\n    background: rgba(255, 255, 255, 0.12);\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    box-shadow: var(--shadow);\n    padding: 14px 12px;\n    margin-top: 10px;\n  }\n  .heroLatestReportBadgeWrap {\n            width: 100%;\n        max-width: 143px;\n        margin: 8px 8px 8px 8px;\n        display: flex;\n        justify-self: center;\n        position: relative;\n        z-index: 1;\n  }\n  .heroLatestReportBadgeWrap .latestReportBadge {\n    width: 100%;\n    justify-content: space-between;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(226, 243, 255, 0.94));\n    box-shadow: 0 12px 24px rgba(7, 55, 112, 0.22);\n  }\n.heroBottom {\n          margin-top: 15px;\n        /* font-weight: 500; */\n        color: rgb(255, 255, 255);\n        letter-spacing: 0.01em;\n        font-size: 12px;\n        font-size: large;\n        /* text-align: center; */\n        /* width: 90%; */\n        margin-left: 15px;\n        z-index: 999;\n        position: relative;\n        display:none;\n}\n  .hero{ padding: 8px 0 6px; }\n  .heroInner{ gap: 1px; }\n  \n \n\n    .heroQuestion{\n      font-size: clamp(16px, 1.0vw, 46px);\n      line-height: 1.05;\n      font-weight: 700;\n      letter-spacing: 0.03em;\n      margin-left:10px;\n      padding-bottom:10px;\n      \n      \n    }\n    .heroByline{\n        margin-left: 15px;\n        margin-right: 15px;\n        padding-bottom: 4px;\n        padding-top: 5px;\n        font-size: 21px;\n        justify-self: center;\n        text-align: center;\n    }\n\n  .heroFinePrint{ \n    font-weight: 500;\n        color: rgba(255, 255, 255);\n        padding-left: 12px;\n        font-size: 13px;\n        letter-spacing: .02em;\n        margin-top: 1px;\n        margin-bottom: 8px;\n  }\n\n\n  .heroLeft {\n    display: flex;\n    justify-content: center;\n  }\n\n  .personaBlock {\n    margin: 0;\n    height: 180px;\n  }\n\n  .personaImg {\n    width: auto;\n    max-width: 160px;\n    max-height: 180px;\n    height: auto;\n    object-fit: contain;\n  }\n  \n\n \n  .heroQuestion{\n            font-size: clamp(17px, 2.0vw, 46px);\n        color: #ffffff;\n        line-height: 1.05;\n        font-weight: 700;\n        letter-spacing: -.02em;\n        margin-top: 6px;\n        margin-bottom: 1px;\n        text-align: center;\n  \n  } \n\n  .heroForm{ \n    padding: 2px;\n        border-radius: 20px;\n        /* margin-top: 5px; */\n        text-align: center;\n        width: 93%; \n        justify-self: center;\n  }\n  .formRow{ \n    flex-wrap: wrap;\n    flex-direction: column; \n    text-align: center; \n    align-content: center;\n  }\n  .ctaBtn{ width:180px; min-width: 0; text-align: center; align-content: center}\n\n \n  .projectCard{ \n            max-width: 400px;\n        width: 95%;\n        justify-self: center;\n  }\n  \n\n  \n}\n\n\n@media (max-width: 375px) {\n    .logoImage {\n        width: 34px;\n        max-width: 34px;\n    }\n    .brand {\n        font-size: 22px;\n    }\n    .tagline {\n        font-size: 8px;\n    }\n}\n    \n\n@media (max-width: 330px) {\n    .brand {\n        font-size: 17px;\n    }\n}\n    \n\n @media (max-width: 550px){\n      .financing-widget-left-submitted{\n        display: none;\n      }\n\n      .financing-widget-disclaimer {\n          margin-top: 10px;\n          font-size: 12px;\n          color: #6b7280;\n          width: 80%;\n          justify-self: center;\n          text-align: center;\n      }\n    }\n\nhtml[data-brand=\"house-helper\"] .page {\n  background: #fbfdf8;\n}\n\nhtml[data-brand=\"house-helper\"] .header {\n  background: rgba(255, 255, 255, 0.78);\n  border-bottom-color: rgba(47, 125, 50, 0.18);\n}\n\nhtml[data-brand=\"house-helper\"] .logo {\n  color: #17351c;\n}\n\nhtml[data-brand=\"house-helper\"] .logoMark {\n  color: var(--brandAccent);\n  border-color: rgba(47, 125, 50, 0.18);\n  box-shadow: 0 10px 24px rgba(47, 125, 50, 0.14);\n}\n\nhtml[data-brand=\"house-helper\"] .brand,\nhtml[data-brand=\"house-helper\"] .brandEm,\nhtml[data-brand=\"house-helper\"] .brand_small,\nhtml[data-brand=\"house-helper\"] .regtrade {\n  color: var(--brandPrimaryDark);\n}\n\nhtml[data-brand=\"house-helper\"] .dot {\n  color: var(--brandAccent);\n}\n\nhtml[data-brand=\"house-helper\"] .tagline,\nhtml[data-brand=\"house-helper\"] .contractorLink {\n  color: #285c31;\n}\n\nhtml[data-brand=\"house-helper\"] .contractorLink {\n  border-color: rgba(47, 125, 50, 0.24);\n  background: rgba(237, 248, 231, 0.72);\n}\n\nhtml[data-brand=\"house-helper\"] .contractorLink:hover {\n  background: rgba(244, 196, 48, 0.28);\n}\n\nhtml[data-brand=\"house-helper\"] .heroBg {\n  background:\n    radial-gradient(1000px 520px at 14% 24%, rgba(255, 255, 255, 0.26), transparent 58%),\n    radial-gradient(760px 460px at 86% 28%, rgba(244, 196, 48, 0.22), transparent 54%),\n    linear-gradient(160deg, var(--bgTop), var(--bgMid));\n}\n\nhtml[data-brand=\"house-helper\"] .heroForm {\n  background: rgba(255, 255, 255, 0.18);\n  border-color: rgba(255, 255, 255, 0.28);\n  box-shadow: 0 12px 28px rgba(24, 83, 33, 0.2);\n}\n\nhtml[data-brand=\"house-helper\"] .ctaBtn,\nhtml[data-brand=\"house-helper\"] .browseProvidersBtn,\nhtml[data-brand=\"house-helper\"] .providersSearchButton,\nhtml[data-brand=\"house-helper\"] .provider-cta-button,\nhtml[data-brand=\"house-helper\"] .provider-request-button,\nhtml[data-brand=\"house-helper\"] .faqPage__button,\nhtml[data-brand=\"house-helper\"] .financing-widget-calc {\n  background: linear-gradient(180deg, var(--brandPrimaryBright), var(--brandPrimary));\n  color: #ffffff;\n  box-shadow: 0 12px 24px rgba(47, 125, 50, 0.22);\n}\n\nhtml[data-brand=\"house-helper\"] .ctaBtn:hover,\nhtml[data-brand=\"house-helper\"] .browseProvidersBtn:hover,\nhtml[data-brand=\"house-helper\"] .providersSearchButton:hover,\nhtml[data-brand=\"house-helper\"] .provider-cta-button:hover,\nhtml[data-brand=\"house-helper\"] .provider-request-button:hover,\nhtml[data-brand=\"house-helper\"] .faqPage__button:hover,\nhtml[data-brand=\"house-helper\"] .financing-widget-calc:hover {\n  background: linear-gradient(180deg, #66aa36, var(--brandPrimaryDark));\n}\n\nhtml[data-brand=\"house-helper\"] .ctaBtn:disabled {\n  background: linear-gradient(180deg, #94bd83, #5f8f5f);\n}\n\nhtml[data-brand=\"house-helper\"] .projectCard,\nhtml[data-brand=\"house-helper\"] .crossSiteProjectSelector,\nhtml[data-brand=\"house-helper\"] .browseProvidersCTA,\nhtml[data-brand=\"house-helper\"] .providersSearchCard,\nhtml[data-brand=\"house-helper\"] .providersTableWrap,\nhtml[data-brand=\"house-helper\"] .provider-table-card,\nhtml[data-brand=\"house-helper\"] .provider-gallery-card,\nhtml[data-brand=\"house-helper\"] .provider-photo-card,\nhtml[data-brand=\"house-helper\"] .provider-cta-card {\n  border-color: #bebfc1;\n  box-shadow: var(--shadowSoft);\n}\n\nhtml[data-brand=\"house-helper\"] .projectCard:hover {\n  box-shadow: 0 18px 38px rgba(24, 83, 33, 0.16);\n}\n\nhtml[data-brand=\"house-helper\"] .projectTitle,\nhtml[data-brand=\"house-helper\"] .projectCardTitle,\nhtml[data-brand=\"house-helper\"] .browseProvidersHeader {\n  color: var(--brandPrimary);\n}\n\nhtml[data-brand=\"house-helper\"] .crossSiteProjectSelectorLabel {\n  color: #ffffff;\n}\n\nhtml[data-brand=\"house-helper\"] .toolsGrid-bubble {\n  border-color: rgba(124, 194, 67, 0.5);\n  background: linear-gradient(180deg, rgba(237, 248, 231, 0.72), rgba(255, 255, 255, 0.96));\n}\n\nhtml[data-brand=\"house-helper\"] .providersPage {\n  background: #f3f8ef;\n}\n\nhtml[data-brand=\"house-helper\"] .providersInput:focus,\nhtml[data-brand=\"house-helper\"] .providersSelect:focus,\nhtml[data-brand=\"house-helper\"] .financing-widget-field input:focus,\nhtml[data-brand=\"house-helper\"] .financing-widget-field select:focus {\n  border-color: var(--brandPrimary);\n  box-shadow: 0 0 0 2px rgba(47, 125, 50, 0.22);\n}\n\nhtml[data-brand=\"house-helper\"] .providersTable thead,\nhtml[data-brand=\"house-helper\"] .providersTable tbody tr:hover {\n  background: var(--brandPrimarySoft);\n}\n\nhtml[data-brand=\"house-helper\"] .providersProfileButton {\n  background: var(--brandPrimary);\n}\n\nhtml[data-brand=\"house-helper\"] .providersProfileButton:hover {\n  background: var(--brandPrimaryDark);\n}\n\nhtml[data-brand=\"house-helper\"] .provider-hero {\n  background: linear-gradient(135deg, var(--brandPrimaryDark), var(--brandPrimaryBright));\n}\n\n@media (max-width: 550px) {\n  .projects .container {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n  }\n\n  .projectsLayout {\n    display: block;\n    width: 100%;\n    max-width: 430px;\n    margin: 0 auto;\n    padding: 0 14px 20px;\n  }\n\n  .projectsMain {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .projectsGrid,\n  .projectsGrid.projectsGrid--twoCol {\n    display: grid;\n    width: 100%;\n    max-width: 100%;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px;\n    justify-self: auto;\n  }\n\n  .projectCard {\n    width: 100%;\n    max-width: none;\n    min-width: 0;\n    min-height: 156px;\n    padding: 12px 8px 16px;\n    border-radius: 18px;\n  }\n\n  .projectIcon img {\n    width: 84px;\n    height: 84px;\n    object-fit: contain;\n  }\n\n  .projectCardTitle {\n    width: 100%;\n    margin-top: -8px;\n    font-size: 15px;\n    line-height: 1.12;\n    overflow-wrap: anywhere;\n  }\n\n  .projectsSidebar {\n    position: static;\n    top: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 100%;\n    margin: 18px auto 0;\n  }\n\n  .projectsSidebar .crossSiteProjectSelector {\n    width: 100%;\n    max-width: 330px;\n    min-height: 214px;\n    margin: 0 auto 12px;\n    padding: 16px 14px 18px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    position: relative;\n    overflow: hidden;\n    isolation: isolate;\n    border: 1px solid rgba(226, 232, 240, 0.9);\n    border-radius: 22px;\n    background:\n      radial-gradient(130px 90px at 82% 10%, rgba(255, 255, 255, 0.78), transparent 70%),\n      linear-gradient(160deg, #dff3ff 0%, #64bee8 45%, #016faf 100%);\n    box-shadow: 0 16px 32px rgba(13, 27, 42, 0.14);\n    color: #ffffff;\n    cursor: pointer;\n  }\n\n  .projectsSidebar .crossSiteProjectSelector::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background:\n      linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(13, 27, 42, 0.22)),\n      radial-gradient(220px 100px at 50% 110%, rgba(255, 255, 255, 0.42), transparent 72%);\n  }\n\n  .projectsSidebar .crossSiteProjectSelector--house-helper {\n    background:\n      radial-gradient(130px 90px at 82% 10%, rgba(255, 255, 255, 0.78), transparent 70%),\n      linear-gradient(160deg, #c8efad 0%, #7cc243 42%, #2f7d32 100%);\n  }\n\n  .projectsSidebar .crossSiteProjectSelector--home-helper {\n    background:\n      radial-gradient(130px 90px at 82% 10%, rgba(255, 255, 255, 0.78), transparent 70%),\n      linear-gradient(160deg, #dff3ff 0%, #64bee8 45%, #016faf 100%);\n  }\n\n  .projectsSidebar .crossSiteProjectSelectorMascot {\n    position: absolute;\n    right: -10px;\n    top: 8px;\n    width: 94px;\n    height: auto;\n    max-width: none;\n  }\n\n  .projectsSidebar .crossSiteProjectSelectorContent {\n    width: min(100%, 190px);\n    position: relative;\n    z-index: 1;\n  }\n\n  .projectsSidebar .crossSiteProjectSelectorEyebrow {\n    display: inline-flex;\n    align-items: center;\n    min-height: 24px;\n    padding: 4px 8px;\n    margin: 0 0 8px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.78);\n    color: #005d97;\n    font-size: 10px;\n    line-height: 1;\n    font-weight: 900;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n  }\n\n  .projectsSidebar .crossSiteProjectSelector--house-helper .crossSiteProjectSelectorEyebrow {\n    color: #1b5e20;\n  }\n\n  .projectsSidebar .crossSiteProjectSelectorLabel {\n    font-size: 21px;\n    line-height: 1.04;\n    display: block;\n    margin: 0 0 7px;\n    color: #ffffff;\n    font-weight: 900;\n    text-shadow: 0 2px 8px rgba(13, 27, 42, 0.28);\n  }\n\n  .projectsSidebar .crossSiteProjectSelectorCopy {\n    max-width: 190px;\n    font-size: 12px;\n    margin: 0 0 12px;\n    color: rgba(255, 255, 255, 0.94);\n    line-height: 1.22;\n    font-weight: 750;\n    text-shadow: 0 1px 7px rgba(13, 27, 42, 0.28);\n  }\n\n  .projectsSidebar .crossSiteProjectSelectorSelect {\n    width: 100%;\n    max-width: none;\n    min-height: 46px;\n    position: relative;\n    z-index: 1;\n    border-radius: 14px;\n    border: 1px solid rgba(13, 27, 42, 0.24);\n    background: #ffffff;\n    color: var(--ink);\n    font-weight: 800;\n    padding: 0 12px;\n    box-shadow: 0 10px 22px rgba(13, 27, 42, 0.16);\n  }\n\n  .projectsSidebar .propertyReportCTA,\n  .projectsSidebar .browseProvidersCTA,\n  .projectsSidebar .homepageCalculatorWrap {\n    width: 100%;\n    max-width: 330px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
